<template>
  <table :id="cpntId" class="cpnt-tabela" @mouseleave="focusL = ''" ref="tabela">
    <caption v-if="liberado === false">
      &nbsp;
    </caption>

    <thead @mouseover="focusL = ''">
      <!-- MONTA O CABECALHO DA TABELA -->
      <tr v-if="[ '', null, undefined ].indexOf($slots) === -1 && [ '', null, undefined ].indexOf($slots.cabecalho) === -1">
        <td :colspan="colunas.length">
          <slot name="cabecalho"></slot>
        </td>
      </tr>

      <!-- SETA O TITULO DA TABELA -->
      <tr v-if="cpntTabelaMostrarTitulo">
        <td :colspan="colunas.length" class="cpnt-tabela-titulo" :class="total !== '__INICIAL__' ? 'cpnt-tabela-bt-paginacao' : ''">
          <!-- SETA O SLOT DOS BOTOES -->
          <slot name="botoes"></slot>

          <!-- MODIFICAR -->
          <button :key="'cpntBotaoAtualizar--' + cpntBotaoAtualizar" v-if="cpntBotaoAtualizar !== null" :disabled="cpntBotaoAtualizar === 'carregando'" class="btn btn-warning btn-sm" title="Clique aqui para salvar as alterações." @click="cpntBotaoAtualizar">
            <!-- SETA O STATUS DO BOTÃO -->
            <App-Status :cpntStatus="cpntBotaoAtualizar" v-if="cpntBotaoAtualizar === 'carregando'" style="width: 90%; margin: 0px auto;"></App-Status>

            <!-- COLOCA O ICONE -->
            <svg v-else class="fas fa-redo-alt"></svg>
          </button>

          <!-- MODIFICAR -->
          <button :key="'cpntBotaoModificar--' + cpntBotaoModificar" v-if="editar !== '' && cpntBotaoModificar !== null" :disabled="cpntBotaoModificar === 'carregando'" class="btn btn-warning btn-sm" title="Clique aqui para salvar as alterações." @click="cpntBotaoModificar">
            <!-- SETA O STATUS DO BOTÃO -->
            <App-Status :cpntStatus="cpntBotaoModificar" v-if="cpntBotaoModificar === 'carregando'" style="width: 90%; margin: 0px auto;"></App-Status>

            <!-- COLOCA O ICONE -->
            <svg v-else class="fa fa-retweet"></svg>
          </button>

          <!-- CANCELAR MODIFICAÇÃO -->
          <button :key="'cpntBotaoCancelar--' + cpntBotaoModificaCancela" v-if="editar !== '' && cpntBotaoModificaCancela !== null" :disabled="cpntBotaoModificaCancela === 'carregando'" class="btn btn-default btn-sm" title="Clique aqui para cancelar as alterações." @click="cpntBotaoModificaCancela">
            <!-- SETA O STATUS DO BOTÃO -->
            <App-Status :cpntStatus="cpntBotaoModificaCancela" v-if="cpntBotaoModificaCancela === 'carregando'" style="width: 90%; margin: 0px auto;"></App-Status>

            <!-- COLOCA O ICONE -->
            <svg v-else class="fa fa-times"></svg>
          </button>

          <!-- EDITAR -->
          <button v-if="cpntBotaoEditar !== null && editar === ''" class="btn btn-warning btn-sm" title="Clique aqui para editar." @click="cpntBotaoEditar">
            <svg class="fa fa-pencil-alt"></svg>
          </button>

          <!-- EXCLUIR -->
          <button :key="'cpntBotaoExcluir--' + cpntBotaoExcluir" v-if="cpntBotaoExcluir !== null && editar === ''" :disabled="cpntBotaoExcluir === 'carregando'"  class="btn btn-danger btn-sm" title="Clique aqui para excluir." @click="cpntBotaoExcluir">
            <!-- SETA O STATUS DO BOTÃO -->
            <App-Status :cpntStatus="cpntBotaoExcluir" v-if="cpntBotaoExcluir === 'carregando'" style="width: 90%; margin: 0px auto;"></App-Status>

            <!-- COLOCA O ICONE -->
            <svg v-else class="fa fa-trash"></svg>
          </button>

          <!-- COPIAR -->
          <button :key="'cpntBotaoCopiar--' + cpntBotaoCopiar" v-if="cpntBotaoCopiar !== null && editar === ''" :disabled="cpntBotaoCopiar === 'carregando'" class="btn btn-default btn-sm" title="Clique aqui para copiar o cadastro." @click="cpntBotaoCopiar">
            <!-- SETA O STATUS DO BOTÃO -->
            <App-Status :cpntStatus="cpntBotaoCopiar" v-if="cpntBotaoCopiar === 'carregando'" style="width: 90%; margin: 0px auto;"></App-Status>

            <!-- COLOCA O ICONE -->
            <svg v-else class="far fa-copy"></svg>
          </button>

          <!-- MINHA PERSONALIZAÇÃO -->
          <template v-if="cpntMostrarMper === true && editar === ''">
            <!-- BOTAO -->
            <button ref="btMper" class="btn btn-default btn-sm" title="Clique aqui para personalizar a tabela." @click="cpntTabelaMostrarMPer">
              <slot name="mper-icone">
                <svg class="fa fa-cog"></svg>
              </slot>
            </button>

            <!-- CONTEUDO -->
            <RF-Dialog-Referencia v-if="mostrarMPer === true" :cpntElement="$refs.btMper" :cpntOnFechar="cpntTabelaMostrarMPer" :cpntPositionFixed="true" class="cpnt-tabela-mper">
              <template slot="titulo" v-if="cpntApiTabPer !== null">
                <div class="mper-titulo">
                  <!-- SETA O TITULO -->
                  <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
                  Minha Personalização
                  
                  <!-- SETA O BOTÃO SALVAR -->
                  <RF-Button :data-time="time" 
                    :cpntId='mPer.salvar.id'
                    :cpntStatus='mPer.salvar.status' 
                    :cpntIcone='mPer.salvar.icone'
                    :cpntTexto='mPer.salvar.texto'
                    :cpntClass='mPer.salvar.class'
                    :cpntDisabled="mPer.salvar.disabled"
                    @onClickButton='mPer.salvar.onClick'
                  ></RF-Button>
                </div>
              </template>

              <div class="mper-fields">
                <div class="filtros" v-if="cpntApiTabPerFiltros === true">
                  <!-- SETA O TITULO -->
                  <span class="titulo">Filtro padrão:</span>
                  <!-- SELETOR DA ORDENAÇÃO -->
                  <App-Select :data-time="time"
                    :cpntStatus='mPer.filtros.status'
                    :cpntId='mPer.filtros.id'
                    :cpntTabIndex='mPer.filtros.tabIndex'
                    :cpntNome='mPer.filtros.nome'
                    :cpntValue='mPer.filtros.value'
                    :cpntMensagem='mPer.filtros.mensagem'
                    :cpntMensagemTipo='mPer.filtros.mensagemTipo'
                    :cpntDisabled='mPer.filtros.disabled'
                    :cpntMostrar='mPer.filtros.mostrar'
                    :cpntExplica='mPer.filtros.explica'
                    :cpntPlaceholder='mPer.filtros.placeholder'
                    :cpntValueRef='mPer.filtros.valueRef'
                    :cpntOptionInicialNome='mPer.filtros.optionInicialNome'
                    :cpntOptionInicialValue='mPer.filtros.optionInicialValue'
                    :cpntRouter='mPer.filtros.router'
                    :cpntMethod='mPer.filtros.method'
                    :cpntField='mPer.filtros.field'
                    :cpntWhere='mPer.filtros.where'
                    :cpntAddButForm='mPer.filtros.addButForm'
                    :cpntKeyMostra='mPer.filtros.keyMostra'
                    :cpntTipoOrder='mPer.filtros.tipoOrder'
                    :cpntOrder='mPer.filtros.order'
                    :cpntOptions='mPer.filtros.options'
                    :cpntKeyValue='mPer.filtros.keyValue'
                    :cpntSearchMinimo='mPer.filtros.searchMinimo'
                    :cpntMask='mPer.filtros.mask'

                    :cpntOnBuscarOptions='mPer.filtros.onBuscarOptions'
                    :cpntOnChange='mPer.filtros.onChange'
                    :cpntOnBlur='mPer.filtros.onBlur'
                    :cpntOnRealizaBusca='mPer.filtros.onRealizaBusca'
                    :cpntOnKeyPressEnter='mPer.filtros.onKeyPressEnter'
                  ></App-Select>
                </div>

                <div class="rpp" v-if="cpntApiTabPerRpp !== null">
                  <!-- SETA O TITULO -->
                  <span class="titulo">Apresentar</span>

                  <!-- SELETOR DA ORDENAÇÃO -->
                  <App-Select :data-time="time"
                    :cpntStatus='mPer.rpp.status'
                    :cpntId='mPer.rpp.id'
                    :cpntTabIndex='mPer.rpp.tabIndex'
                    :cpntNome='mPer.rpp.nome'
                    :cpntValue='mPer.rpp.value'
                    :cpntMensagem='mPer.rpp.mensagem'
                    :cpntMensagemTipo='mPer.rpp.mensagemTipo'
                    :cpntDisabled='mPer.rpp.disabled'
                    :cpntMostrar='mPer.rpp.mostrar'
                    :cpntExplica='mPer.rpp.explica'
                    :cpntPlaceholder='mPer.rpp.placeholder'
                    :cpntValueRef='mPer.rpp.valueRef'
                    :cpntRouter='mPer.rpp.router'
                    :cpntMethod='mPer.rpp.method'
                    :cpntField='mPer.rpp.field'
                    :cpntWhere='mPer.rpp.where'
                    :cpntAddButForm='mPer.rpp.addButForm'
                    :cpntKeyMostra='mPer.rpp.keyMostra'
                    :cpntTipoOrder='mPer.rpp.tipoOrder'
                    :cpntOrder='mPer.rpp.order'
                    :cpntOptions='cpntApiTabPerRpp'
                    :cpntKeyValue='mPer.rpp.keyValue'
                    :cpntSearchMinimo='mPer.rpp.searchMinimo'
                    :cpntMask='mPer.rpp.mask'

                    :cpntOnBuscarOptions='mPer.rpp.onBuscarOptions'
                    :cpntOnChange='mPer.rpp.onChange'
                    :cpntOnBlur='mPer.rpp.onBlur'
                    :cpntOnRealizaBusca='mPer.rpp.onRealizaBusca'
                    :cpntOnKeyPressEnter='mPer.rpp.onKeyPressEnter'
                  ></App-Select>

                  <!-- FINALIZA O TITULO -->
                  <span class='titulo'>registros por página</span>
                </div>

                <div class="order" v-if="cpntApiTabPerOrder !== null">
                  <!-- SETA O TITULO -->
                  <span class="titulo">Ordenado por:</span>

                  <!-- SELETOR DA ORDENAÇÃO -->
                  <App-Select :data-time="time"
                    :cpntStatus='mPer.order.status'
                    :cpntId='mPer.order.id'
                    :cpntTabIndex='mPer.order.tabIndex'
                    :cpntNome='mPer.order.nome'
                    :cpntValue='mPer.order.value'
                    :cpntMensagem='mPer.order.mensagem'
                    :cpntMensagemTipo='mPer.order.mensagemTipo'
                    :cpntDisabled='mPer.order.disabled'
                    :cpntMostrar='mPer.order.mostrar'
                    :cpntExplica='mPer.order.explica'
                    :cpntPlaceholder='mPer.order.placeholder'
                    :cpntValueRef='mPer.order.valueRef'
                    :cpntRouter='mPer.order.router'
                    :cpntMethod='mPer.order.method'
                    :cpntField='mPer.order.field'
                    :cpntWhere='mPer.order.where'
                    :cpntAddButForm='mPer.order.addButForm'
                    :cpntKeyMostra='mPer.order.keyMostra'
                    :cpntTipoOrder='mPer.order.tipoOrder'
                    :cpntOrder='mPer.order.order'
                    :cpntOptions='cpntApiTabPerOrder'
                    :cpntKeyValue='mPer.order.keyValue'
                    :cpntSearchMinimo='mPer.order.searchMinimo'
                    :cpntMask='mPer.order.mask'

                    :cpntOnBuscarOptions='mPer.order.onBuscarOptions'
                    :cpntOnChange='mPer.order.onChange'
                    :cpntOnBlur='mPer.order.onBlur'
                    :cpntOnRealizaBusca='mPer.order.onRealizaBusca'
                    :cpntOnKeyPressEnter='mPer.order.onKeyPressEnter'
                  ></App-Select>
                </div>

                <div class="fields">
                  <!-- SETA O TITULO -->
                  <span class="titulo">Mostrar as colunas marcadas na tabela:</span>

                  <!-- SETA O BOTÃO PARA SELECIONAR TODOS -->
                  <App-Button v-if="[ '', null, undefined ].indexOf($slots['mper-icone']) === -1"
                  :cpntClass="[ 'btn', 'btn-default', 'btn-sm' ]" 
                  @onClick="cpntTabelaMPerCheckboxSelecionarTodos">
                    Selecionar todos
                  </App-Button>

                  <!-- CHECKBOXS -->
                  <div class="campos">
                    <template v-for="(coluna, indexC) in colunas">
                      <div v-if="coluna.mPer <= 2" :key="'mper--field--' + indexC">
                        <input :id='cpntId + coluna.chave' type="checkbox" class="app-checkbox" @change="cpntTabelaMPerCheckboxOnChange" :checked="mPer.checkbox.indexOf(coluna.chave) !== -1" :value="coluna.chave" :disabled="coluna.mPer >= 2">
                        <label :for='cpntId + coluna.chave' v-html="coluna.nome"></label>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </RF-Dialog-Referencia>
          </template>

          <template v-if="[ '', null, undefined ].indexOf(cpntBotaoExportar) === -1">
            <App-Button :data-time="time" v-if="cpntBotaoExportar.format.indexOf('xlsx') !== -1" :cpntStatus='botaoExportarXLSXStatus' @onClick='() => { cpntTabelaAcaoExportar("xlsx") }'  title="Clique aqui para exportar para excel esta pesquisa.">
              <svg class="far fa-file-excel"></svg>
            </App-Button>

            <App-Button :data-time="time" v-if="cpntBotaoExportar.format.indexOf('pdf') !== -1" :cpntStatus='botaoExportarPDFStatus' @onClick='() => { cpntTabelaAcaoExportar("pdf") }'  title="Clique aqui para exportar para pdf esta pesquisa.">
              <svg class="far fa-file-pdf"></svg>
            </App-Button>
          </template>

          <!-- COPIAR -->
          <button :key="'cpntBotaoImprimir--' + cpntBotaoImprimir" v-if="cpntBotaoImprimir === true" :disabled="imprimir === 'carregando'" class="btn btn-default btn-sm" title="Clique aqui para copiar o cadastro." @click="cpntTabelaImprimir">
            <!-- SETA O STATUS DO BOTÃO -->
            <App-Status :cpntStatus="imprimir" v-if="imprimir === 'carregando'" style="width: 90%; margin: 0px auto;"></App-Status>

            <!-- COLOCA O ICONE -->
            <svg v-else class="fa fa-print"></svg>
          </button>

          <!-- SETA O SLOT DOS BOTOES -->
          <slot name="botoes2"></slot>

          <!-- PAGINAÇÃO -->
          <div class="paginacao" v-if="total !== '__INICIAL__'">
            <App-Button :data-time="time"
              :cpntId='paginacao.anterior.id'
              :cpntStatus='paginacao.anterior.status' 
              :cpntIcone='paginacao.anterior.icone'
              :cpntClass='paginacao.anterior.class'
              :cpntDisabled="cpntTabelaPaginacaoPassadorAnterior === true || this.statusGeral !== '' || this.liberado !== true"
              @onClick='paginacao.anterior.onClick'
            ></App-Button>
            
            <App-Select :data-time="time" v-if="paginacao.pagina.options.length <= 700"
              :cpntStatus='paginacao.pagina.status'
              :cpntId='paginacao.pagina.id'
              :cpntTabIndex='paginacao.pagina.tabIndex'
              :cpntNome='paginacao.pagina.nome'
              :cpntValue='paginacao.pagina.value'
              :cpntMensagem='paginacao.pagina.mensagem'
              :cpntMensagemTipo='paginacao.pagina.mensagemTipo'
              :cpntDisabled='paginacao.pagina.disabled'
              :cpntMostrar='paginacao.pagina.mostrar'
              :cpntExplica='paginacao.pagina.explica'
              :cpntPlaceholder='paginacao.pagina.placeholder'
              :cpntValueRef='paginacao.pagina.valueRef'
              :cpntRouter='paginacao.pagina.router'
              :cpntMethod='paginacao.pagina.method'
              :cpntField='paginacao.pagina.field'
              :cpntWhere='paginacao.pagina.where'
              :cpntAddButForm='paginacao.pagina.addButForm'
              :cpntKeyMostra='paginacao.pagina.keyMostra'
              :cpntTipoOrder='paginacao.pagina.tipoOrder'
              :cpntOrder='paginacao.pagina.order'
              :cpntOptions='paginacao.pagina.options'
              :cpntKeyValue='paginacao.pagina.keyValue'
              :cpntSearchMinimo='paginacao.pagina.searchMinimo'
              :cpntMask='paginacao.pagina.mask'

              :cpntOnBuscarOptions='paginacao.pagina.onBuscarOptions'
              :cpntOnChange='paginacao.pagina.onChange'
              :cpntOnBlur='paginacao.pagina.onBlur'
              :cpntOnRealizaBusca='paginacao.pagina.onRealizaBusca'
              :cpntOnKeyPressEnter='paginacao.pagina.onKeyPressEnter'
            ></App-Select>

            <template v-else>
              <App-Input :data-time="time" :class="paginacao.pagina.id"  style="margin-right: 2px;"  title="Página atual"
                :cpntStatus='paginacao.pagina.status'
                :cpntId='paginacao.pagina.id'
                :cpntClassDivField='paginacao.pagina.classDivField'
                :cpntNome='paginacao.pagina.nome'
                :cpntValue='typeof paginacao.pagina.value === "string" ? paginacao.pagina.value : paginacao.pagina.value.id'
                :cpntAutoComplete='paginacao.pagina.autocomplete'
                :cpntMask='paginacao.pagina.mask'
                :cpntOptionInicialNome='paginacao.pagina.optionInicialNome'
                :cpntOptionInicialValue='paginacao.pagina.optionInicialValue'
                :cpntDisabled='paginacao.pagina.disabled'
                :cpntMostrar='paginacao.pagina.mostrar'
                :cpntExplica='paginacao.pagina.explica'
                :cpntAutoFocus='paginacao.pagina.autofocus'
                :cpntMensagem='paginacao.pagina.mensagem'
                :cpntMensagemTipo='paginacao.pagina.mensagemTipo'
                :cpntPlaceholder='paginacao.pagina.placeholder'
                :cpntPosicionar='paginacao.pagina.posicionar'

                :cpntOnChange='cpntTabelaAlterarPaginaInputOnChange'
                :cpntOnBlur='cpntTabelaAlterarPaginaInputOnBlur'
                :cpntOnKeyPressEnter='paginacao.pagina.onKeyPressEnter'
                :ref="paginacao.pagina.id"
              ></App-Input>

              de 
              
              <App-Input :data-time="time" :class="paginacao.pagina.id" style="margin-left: 2px; margin-right: 5px;" title="Total de páginas"
                :cpntStatus='paginacao.pagina.status'
                :cpntId='paginacao.pagina.id + "-disabled"'
                :cpntClassDivField='paginacao.pagina.classDivField'
                :cpntNome='paginacao.pagina.nome'
                :cpntValue='paginacao.pagina.options.length'
                :cpntAutoComplete='paginacao.pagina.autocomplete'
                :cpntMask='paginacao.pagina.mask'
                :cpntOptionInicialNome='paginacao.pagina.optionInicialNome'
                :cpntOptionInicialValue='paginacao.pagina.optionInicialValue'
                :cpntDisabled='true'
                :cpntMostrar='paginacao.pagina.mostrar'
                :cpntExplica='paginacao.pagina.explica'
                :cpntAutoFocus='paginacao.pagina.autofocus'
                :cpntMensagem='paginacao.pagina.mensagem'
                :cpntMensagemTipo='paginacao.pagina.mensagemTipo'
                :cpntPlaceholder='paginacao.pagina.placeholder'
                :cpntPosicionar='paginacao.pagina.posicionar'

                :cpntOnChange='cpntTabelaAlterarPaginaInputOnChange'
                :cpntOnBlur='cpntTabelaAlterarPaginaInputOnBlur'
                :cpntOnKeyPressEnter='paginacao.pagina.onKeyPressEnter'
                :ref="paginacao.pagina.id"
              ></App-Input>
            </template>

            <App-Button :data-time="time"
              :cpntId='paginacao.proximo.id'
              :cpntStatus='paginacao.proximo.status' 
              :cpntIcone='paginacao.proximo.icone'
              :cpntClass='paginacao.proximo.class'
              :cpntDisabled="cpntTabelaPaginacaoPassadorProximo === true || this.statusGeral !== '' || this.liberado !== true"
              @onClick='paginacao.proximo.onClick'
            ></App-Button>

            <App-Select :data-time="time" v-if="cpntApiTabPerRpp !== null"
              :cpntStatus='paginacao.rpp.status'
              :cpntId='paginacao.rpp.id'
              :cpntTabIndex='paginacao.rpp.tabIndex'
              :cpntNome='paginacao.rpp.nome'
              :cpntValue='paginacao.rpp.value'
              :cpntMensagem='paginacao.rpp.mensagem'
              :cpntMensagemTipo='paginacao.rpp.mensagemTipo'
              :cpntDisabled='paginacao.rpp.disabled'
              :cpntMostrar='paginacao.rpp.mostrar'
              :cpntExplica='paginacao.rpp.explica'
              :cpntPlaceholder='paginacao.rpp.placeholder'
              :cpntValueRef='paginacao.rpp.valueRef'
              :cpntRouter='paginacao.rpp.router'
              :cpntMethod='paginacao.rpp.method'
              :cpntField='paginacao.rpp.field'
              :cpntWhere='paginacao.rpp.where'
              :cpntAddButForm='paginacao.rpp.addButForm'
              :cpntKeyMostra='paginacao.rpp.keyMostra'
              :cpntTipoOrder='paginacao.rpp.tipoOrder'
              :cpntOrder='paginacao.rpp.order'
              :cpntOptions='cpntApiTabPerRpp'
              :cpntKeyValue='paginacao.rpp.keyValue'
              :cpntSearchMinimo='paginacao.rpp.searchMinimo'
              :cpntMask='paginacao.rpp.mask'

              :cpntOnBuscarOptions='paginacao.rpp.onBuscarOptions'
              :cpntOnChange='paginacao.rpp.onChange'
              :cpntOnBlur='paginacao.rpp.onBlur'
              :cpntOnRealizaBusca='paginacao.rpp.onRealizaBusca'
              :cpntOnKeyPressEnter='paginacao.rpp.onKeyPressEnter'
            ></App-Select>

            <span>Itens por página | </span>
            <span class='destaque'>{{ regIni }}</span>
            <span> - </span>
            <span class='destaque'>{{ regFim }}</span>
            <span> de </span>
            <span class='destaque'>{{ total }}</span>
            <template v-if="fazerOrdenacao === true && cpntApiTabPerOrder !== null && cpntApiTabPerOrder.length >= 1 && [ '', null, undefined ].indexOf($store.state.mPer[cpntApiTabPer]) === -1">
              <span>&nbsp;Ordenado por:&nbsp;</span>
              <span class='destaque' v-html="cpntApiTabPerOrder.filter(item => item.id === $store.state.mPer[cpntApiTabPer].order)[0].nome"></span>
            </template>
          </div>

          <!-- SETA O SLOT DE APRESENTAÇÃO -->
          <slot name="titulo"></slot>

          <!-- SETA A TELA QUE DEVE ABRIR --> 
          <RF-Dialog-Referencia v-if="acoes !== null && $refs[acoes.chave] !== undefined" v-show="ocultar_dialog !== true"
          :cpntElement="$refs[acoes.chave][0]"
          :cpntOnFechar="(event) => { cpntMostrarOcultarAcoesCelula(event, acoes.indexL, acoes.indexC, '') }"
          :cpntAlignX="'top-end'"
          class="cpnt-tabela-acoes">
            <slot name="acoes_celula" v-if="acoes.tipo === 'acoes'"
            v-bind:linha="cpntLinha[acoes.indexL]"
            v-bind:coluna="colunas[acoes.indexC]"
            v-bind:indexL="acoes.indexL"
            v-bind:indexC="acoes.indexC"
            v-bind:indexLC="acoes.indexLC"
            v-bind:hash="acoes.hash"
            v-bind:indexCV="colunas[acoes.indexC].chave">
              <ul>
                <li @click="(event) => { cpntMostrarOcultarAcoesCelula(event, acoes.indexL, acoes.indexC, 'editar') }">
                  <div class="icone">
                    <svg class="fa fa-pencil-alt"></svg>
                  </div>
                  <div class="texto">
                    Editar
                  </div>
                </li>
              </ul>
            </slot>

            <template v-else-if="acoes.tipo === 'editar'">
              <template slot="titulo">
                <slot name="editar_celula_titulo"
                v-bind:linha="cpntLinha[acoes.indexL]"
                v-bind:coluna="colunas[acoes.indexC]"
                v-bind:indexL="acoes.indexL"
                v-bind:indexC="acoes.indexC"
                v-bind:indexLC="acoes.indexLC"
                v-bind:hash="acoes.hash"
                v-bind:indexCV="colunas[acoes.indexC].chave">
                <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
                Editar <span v-html="colunas[acoes.indexC].nome"></span>
                </slot>
              </template>

              <slot name="editar_celula"
              v-bind:linha="cpntLinha[acoes.indexL]"
              v-bind:coluna="colunas[acoes.indexC]"
              v-bind:indexL="acoes.indexL"
              v-bind:indexC="acoes.indexC"
              v-bind:indexLC="acoes.indexLC"
              v-bind:hash="acoes.hash"
              v-bind:indexCV="colunas[acoes.indexC].chave"
              v-bind:chave="acoes.indexL + '--' + colunas[acoes.indexC].chave"
              v-bind:salvar="() => { cpntTabelaAcaoEditarSalvar({ type: 'click' }) }"></slot>

              <template slot="rodape">
                <slot name="editar_celula_rodape"
                v-bind:linha="cpntLinha[acoes.indexL]"
                v-bind:coluna="colunas[acoes.indexC]"
                v-bind:indexL="acoes.indexL"
                v-bind:indexC="acoes.indexC"
                v-bind:indexLC="acoes.indexLC"
                v-bind:hash="acoes.hash"
                v-bind:indexCV="colunas[acoes.indexC].chave">
                <div class="botoes">
                  <RF-Button
                    :cpntStatus='botoesEditar.cancelar.status' 
                    :cpntId='botoesEditar.cancelar.id' 
                    :cpntTexto='botoesEditar.cancelar.texto' 
                    :cpntClass='botoesEditar.cancelar.class'
                    :cpntMostrar='botoesEditar.salvar.mostrar'
                    :cpntTabIndex='botoesEditar.cancelar.tabIndex'
                    @onClickButton='botoesEditar.cancelar.onClick'
                  ></RF-Button>

                  <RF-Button
                    :cpntStatus='botoesEditar.salvar.status' 
                    :cpntId='botoesEditar.salvar.id' 
                    :cpntTexto='botoesEditar.salvar.texto' 
                    :cpntClass='botoesEditar.salvar.class'
                    :cpntMostrar='botoesEditar.salvar.mostrar'
                    :cpntTabIndex='botoesEditar.salvar.tabIndex'
                    @onClickButton='botoesEditar.salvar.onClick'
                  ></RF-Button>
                </div>
                </slot>
              </template>
            </template>
          </RF-Dialog-Referencia>

          <!-- CRIA A DIALOG DE EXPORTAÇÃO -->
          <RF-Dialog v-if="[ '', null, undefined ].indexOf(exportarPagina) === -1"
          :cpntStatus='""'
          :cpntLargura='"400px"'
          :cpntFundoFechar="false"
          :cpntOnFecharDialog='() => {}'>
          <template slot="conteudo">
            <div class="cpnt-tab-exportar">
              <div v-if="exportarStatus === 'carregando'">
                <br/>
                <br/>
                <br/>
                Gerando arquivo {{ exportarPagina.proxima }} de {{ exportarPagina.total }} por favor aguarde...
                <br/>
                <br/>
              </div>
              <template v-else>
                Arquivo {{ exportarPagina.atual }} de {{ exportarPagina.total }} gerado{{ exportarPagina.total >= 2 ? 's' : '' }}.
                <br/>
                <br/>
                Prosseguir para o arquivo {{ exportarPagina.proxima }}? 
                <br/>
                <br/>
                
                <!-- CRIA O BOTÃO SIM -->
                <App-Button :data-time="time" :cpntClass="'btn btn-primary'" @onClick='() => { cpntTabelaAcaoExportar(exportarPagina.formato, exportarPagina.proxima) }'>
                  Sim
                </App-Button>

                <!-- CRIA O BOTÃO NÃO -->
                <App-Button :data-time="time" :cpntClass="'btn btn-default'" @onClick='() => { cpntTabelaAcaoExportarFecharDialog() }'>
                  Não
                </App-Button>
              </template>
            </div>
          </template>
          </RF-Dialog>
        </td>
      </tr>

      <!-- SETA AS COLUNAS QUE DEVEM CONTER NA TELA -->
      <tr v-if="colunas !== '__INICIAL__'">
        <template v-for="(coluna, indexC) in colunas">
          <th v-if="coluna.mPer >= 1" :key="'th-' + indexC" :class="'col_' + coluna.chave">
            <!-- APRESENTA O SLOT DA TELA -->
            <slot :name="'th_' + coluna.chave" v-bind:coluna="coluna">
              <!-- SETA O CHECKBOX DA TABELA -->
              <template v-if="coluna.tipo === 'checkbox'">
                <input :id='cpntId + "--" + coluna.chave' type="checkbox" class="app-checkbox" @change="cpntTabelaCheckboxMarcarTodos" :checked="cpntLinha.length >= 1 && cpntCheckbox.length === cpntLinha.length" :disabled="editar !== ''">
                <label :for='cpntId + "--" + coluna.chave'></label>
              </template>

              <!-- SETA O CONTEUDO DA TABELA -->
              <span v-html="coluna.nome"></span>

              <!-- SETA A EXPLICAÇÃO DA COLUNA -->
              <RF-Explica v-if='[ "", null, undefined ].indexOf(coluna.explica) === -1'
                :cpntTitle='coluna.explica.mensagem'
                :cpntPositionMy='coluna.explica.posicaoMy'
                :cpntPositionAt='coluna.explica.posicaoAt'
                :cpntClasses='coluna.explica.class'
                :cpntMostrar='coluna.explica.mostrar'
                :data-time='time'
              ></RF-Explica>
            </slot>
          </th>
        </template>
      </tr>
    </thead>
    <tbody :class="'qtde-lin--' + cpntLinha.length" ref="tbody">
      <tr v-if="cpntTabelaStatus !== ''">
        <td :colspan="colunas.length">
          <div>
            <span :key="'status--' + time">
              <!-- SETA A MENSAGEM DE CARREGANDO -->
              <div v-if="cpntTabelaStatus === 'carregando'">Por favor, aguarde... <br/><br/></div>

              <!-- COLOCA AS BOLAS DE CARREGANDO -->
              <RF-Status-2 :data-time="time" :cpntStatus='cpntTabelaStatus'></RF-Status-2>
            </span>
          </div>
        </td>
      </tr>
      <tr v-else-if="cpntLinha.length === 0">
        <td :colspan="colunas.length">
          <div>
            <span class="cpnt-tabela-no-results">
              <slot name="no-results">Nenhum registro encontrado</slot>
            </span>
          </div>
        </td>
      </tr>
      <template v-else>
        <template v-for="(linha, indexL) in cpntLinha">
          <tr :key="'tr-' + indexL" :class="cpntTabelaFundoLinha(indexL, linha)" @mouseover="cpntTabelaSetarFocusLinha(indexL)">
            <template v-for="(coluna, indexC) in colunas">
              <td v-if="coluna.mPer >= 1" :set="indexLC = (indexL + '-' + indexC)" :key="'tr-' + indexL + 'td-' + indexC" :class="'col_' + coluna.chave + ' col_tipo_' + coluna.tipo" :ref="'acao-' + (indexL + '-' + indexC)">                
                <div @click="(event) => { cpntMostrarOcultarAcoesCelula(event, indexL, indexC, 'acoes') }">
                  <span>
                    <slot :name="coluna.slot !== undefined ? coluna.slot : ('col_' + coluna.chave)"
                    v-bind:linha="linha"
                    v-bind:coluna="coluna"
                    v-bind:valor="linha[coluna.chave]"
                    v-bind:linhaAdd="linhaAdi.indexOf(linha[cpntKeyValueEditar]) !== -1"
                    v-bind:indexL="indexL"
                    v-bind:indexC="indexC"
                    v-bind:indexCV="coluna.chave">
                      <!-- SETA O CHECKBOX DA TABELA -->
                      <template v-if="coluna.tipo === 'checkbox'">
                        <template v-if="cpntTabelaValidarColunaCheck(coluna.chave, linha, indexL, indexC)">
                          <input :id='cpntId + "--" + coluna.chave + "--" + linha[coluna.chave]' ref="cks" type="checkbox" class="app-checkbox" @change="cpntTabelaCheckboxOnChange" :value="linha[coluna.chave]" :checked="cpntCheckbox.indexOf(linha[coluna.chave]) !== -1"  :disabled="(editar !== '' || linha._disabled_checkbox === true)">
                          <label :for='cpntId + "--" + coluna.chave + "--" + linha[coluna.chave]'></label>
                        </template>
                        <slot v-else :name="'col_' + coluna.chave + '_checkbox'"
                        v-bind:linha="linha"
                        v-bind:coluna="coluna"
                        v-bind:valor="linha[coluna.chave]"
                        v-bind:linhaAdd="linhaAdi.indexOf(linha[cpntKeyValueEditar]) !== -1"
                        v-bind:indexL="indexL"
                        v-bind:indexC="indexC"
                        v-bind:indexCV="coluna.chave"></slot>
                      </template>

                      <template v-else-if="coluna.tipo === 'mostrar'">
                        <div @click="() => { cpntTabelaOnChangeLinhaAdicional(linha[cpntKeyValueEditar]) }" :key="'mostrar-linha-adicional-' + JSON.stringify(linhaAdi)" class="cpnt-tabela-acao-mostrar-linha">
                          <svg v-if="linhaAdi.indexOf(linha[cpntKeyValueEditar]) === -1" class="ocultar_mostrar fa fa-eye-slash"></svg>
                          <svg v-else class="ocultar_mostrar fa fa-eye"></svg>
                        </div>
                      </template>

                      <!-- SETA O CONTEUDO DA TABELA -->
                      <span v-else v-html="linha[coluna.chave]"></span>
                    </slot>
                  </span>
                </div>
              </td>
            </template>
          </tr>
          <tr :key="'tr-edi-' + indexL" v-if="editar !== '' && cpntCheckbox.indexOf(linha[cpntKeyValueEditar]) !== -1">
            <template v-for="(coluna, indexC) in colunas">
              <td class='cpnt-tabela-editar' :class="'col_' + coluna.chave" v-if="coluna.mPer >= 1" :set="indexLC = (indexL + '-' + indexC)" :key="'tr-edi-' + indexL + 'td-' + indexC">
                <div>
                  <span v-if="cpntTabelaVerificarEditar(indexL, indexC)">
                    <slot name="editar_celula"
                    v-bind:linha="cpntLinha[indexL]"
                    v-bind:coluna="colunas[indexC]"
                    v-bind:indexL="indexL"
                    v-bind:indexC="indexC"
                    v-bind:indexLC="indexLC"
                    v-bind:hash="editar"
                    v-bind:indexCV="colunas[indexC].chave"
                    v-bind:chave="indexL + '--' + colunas[indexC].chave"
                    v-bind:salvar="() => { cpntTabelaAcaoEditarSalvar({ type: 'click' }) }"
                    ></slot>
                  </span>
                </div>
              </td>
            </template>
          </tr>
          <tr :key="'tr-adi-' + indexL" v-if="linhaAdi.indexOf(linha[cpntKeyValueEditar]) !== -1" class="cpnt-tabela-linha-adicional">
            <td :colspan="colunas.length">
              <slot :name="'linha_adicional'"
              v-bind:linhaAdi="linhaAdi"
              v-bind:linha="linha"
              v-bind:indexL="indexL">
              </slot>
            </td>
          </tr>
        </template>
      </template>

      <tr v-if="Object.keys($slots).indexOf('tabela_carregar_mais') !== -1">
        <td :colspan="colunas.length" class="carregar_mais">
          <div>
            <span>
              <slot name="tabela_carregar_mais"></slot>
            </span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<style scoped>
  .cpnt-tabela {
    position: relative;
  }
  .cpnt-tabela > caption {
    background: #fefefe;
    opacity: 0.6;
    z-index: 999;
    /* border: 1px solid #000; */

    position: absolute;
    top: 0px;
    width: 100%;
    height: 100%;
    /* margin-top: -83px; */
  }

</style>

<style>

</style>

<script>
import '../../../public/plugins/printElement_201/jquery.printelement.js'
export default {
  props: {
    cpntId: {
      required: false,
      type: String,
      default: function () {
        // INICIA A VARIAVEL ID
        var id = ''

        // INICIA PARA VERIFICAR SE ENCONTROU UM ID
        var flag = false

        // PROCURAR A MONTAGEM DO CAMPO
        while (flag === false) {
          // GERA UM ID PARA O CAMPO
          id = 'cpnt-tabela-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString() + '--'

          // VERIFICA SE O ID GERADO É UNICO NA TELA
          flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
        }

        // RETONAR O VALOR MONTADO
        return id
      }
    },
    cpntStatus: {
      required: false,
      default: function () {
        return ''
      }
    },
    cpntColuna: {
      required: true,
      type: Array
    },
    cpntLinha: {
      required: true,
      type: Array
    },
    cpntCheckbox: {
      required: false,
      type: Array
    },
    cpntBotaoCopiar: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntBotaoImprimir: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntBotaoAtualizar: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntBotaoModificar: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntBotaoModificaCancela: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntKeyValueEditar: {
      required: false,
      default: function () {
        return 'id'
      }
    },
    cpntBotaoEditar: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntSalvarEdicao: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntMostrarMper: {
      required: false,
      default: function () {
        return false
      }
    },
    cpntBotaoExcluir: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntBotaoExportar: {
      required: false,
      default: function () {
        return null
      }
    },

    cpntSetarValores: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntApiTabPerOrder: {
      required: false,
      default: function () {
        return [
          { id: '0', nome: 'Código Decrescente', chave: 'id', order: 'desc' },
          { id: '1', nome: 'Código Crescente', chave: 'id', order: 'asc' }
        ]
      }
    },
    cpntApiTabPerFiltros: {
      required: false,
      default: function () {
        return true
      }
    },
    cpntApiTabPerRpp: {
      required: false,
      default: function () {
        return [
          { id: '5' },
          { id: '10' },
          { id: '15' },
          { id: '20' },
          { id: '25' },
          { id: '30' },
          { id: '35' },
          { id: '40' },
          { id: '45' },
          { id: '50' },
          { id: '55' },
          { id: '60' },
          { id: '65' },
          { id: '70' },
          { id: '75' },
          { id: '80' },
          { id: '85' },
          { id: '90' },
          { id: '95' },
          { id: '100' }
        ]
      }
    },
    cpntApiTabPer: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntApiMethods: {
      required: false,
      default: function () {
        return 'GET'
      }
    },
    cpntApiRouter: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntApiWhere: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntApiGroup: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntApiField: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntApiFieldVirtual: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntApiOrder: {
      required: false,
      default: function () {
        return {}
      }
    },
    cpntApiMontarQueryGet: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntMontarFiltroRelatorio: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntFiltros: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntApiEstruturaQueryGet: {
      required: false,
      default: function () {
        return [
          [ 'type', 'limit', 'field', 'where', 'order', 'group' ]
        ]
      }
    },
    cpntSetarFiltros: {
      required: false,
      default: function () {
        return (callback) => { callback() }
      }
    },
    cpntMontarFiltros: {
      required: false,
      default: function () {
        return (callback) => { callback([]) }
      }
    },
    cpntApiBuscaComplementar: {
      required: false,
      default: function () {
        return (vetor, callback) => { callback(vetor) }
      }
    },
    cpntMontarWhere: {
      required: false,
      default: function () {
        return () => { return null }
      }
    },
    cpntBuscaInicial: {
      required: false,
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  components: {
    'RF-Dialog-Referencia': () => import('@/components/rf-geral/dialog/RF-Dialog-Referencia.vue'),
    'App-Select': () => import('@/components/_geral/Select.vue'),
    'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue'),
    'RF-Status-2': () => import('@/components/rf-geral/status/RF-Status-2.vue')
  },
  data: function () {
    return {
      time: '',
      statusGeral: 'carregando',
      liberado: false,
      botaoExportarXLSXStatus: '',
      botaoExportarPDFStatus: '',
      exportarStatus: '',
      exportarPagina: null,
      filtros: null,
      colunas: '__INICIAL__',
      mostrarMPer: false,
      queryGetForms: null,
      imprimir: '',
      acoes: null,
      fazerOrdenacao: true,
      linhaAdi: [],
      botoesEditar: {
        cancelar: {
          status: '',
          id: this.cpntId + '--acao-editar--cancelar',
          texto: 'Cancelar',
          class: [ 'btn', 'btn-default', 'btn-sm' ],
          mostrar: true,
          onClick: () => { this.cpntTabelaAcaoEditarCancelar({ type: 'click' }) }
        },
        salvar: {
          status: '',
          id: this.cpntId + '--acao-editar--salvar',
          texto: 'Salvar',
          class: [ 'btn', 'btn-primary', 'btn-sm' ],
          mostrar: true,
          onClick: () => { this.cpntTabelaAcaoEditarSalvar({ type: 'click' }) }
        },
      },
      focusL: '',
      ocultar_dialog: false,
      editar: '',
      pagina: 1,
      rpp: 10,
      total: '__INICIAL__',
      qtdePag: 1,
      regIni: 0,
      regFim: 0,
      paginacao: {
        anterior: {
          status: '',
          id: this.cpntId + 'paginacao--anterior',
          icone: 'fa fa-chevron-left',
          class: [ 'btn', 'btn-default', 'btn-sm' ],
          mostrar: true,
          onClick: this.cpntTabelaAlterarPaginaPassador
        },
        pagina: {
          id: this.cpntId + 'paginacao--pagina',
          status: '',
          nome: '',
          keyValue: 'id',
          keyMostra: [ 'id' ],
          options: [],
          value: { id: '1' },
          onChange: this.cpntTabelaAlterarPagina,
          onKeyPressEnter: () => {
            // PEGA O VALOR DO CAMPO
            var valor = typeof this.paginacao.pagina.value === "string" ? this.paginacao.pagina.value : this.paginacao.pagina.value.id

            // CONVERTE O VALOR EM NUMERO
            valor = Number(valor)
            
            // VERIFICA SE O VALOR É DIFERNETE
            if (valor !== this.pagina) {
              this.cpntTabelaAlterarPagina({ id: valor.toString() })
            }
          }
        },
        proximo: {
          status: '',
          id: this.cpntId + 'paginacao--proximo',
          icone: 'fa fa-chevron-right',
          class: [ 'btn', 'btn-default', 'btn-sm' ],
          mostrar: true,
          onClick: this.cpntTabelaAlterarPaginaPassador
        },
        rpp: {
          id: this.cpntId + 'paginacao--rpp',
          status: '',
          nome: '',
          keyValue: 'id',
          keyMostra: [ 'id' ],
          value: { id: '10' },
          onChange: this.cpntTabelaAlterarRpp
        }
      },

      mPer: {
        salvar: {
          status: '',
          id: this.cpntId + 'mper--salvar',
          texto: 'Salvar',
          class: [ 'btn', 'btn-default', 'btn-sm' ],
          mostrar: true,
          onClick: this.cpntTabelaSalvarMPer
        },
        filtros: {
          id: this.cpntId + 'mper--filtros',
          status: '',
          nome: '',
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          optionInicialNome: 'Sem padrão',
          optionInicialValue: '',
          value: '',
          options: [],
          onBuscarOptions: this.cpntTabelaMPerBuscarFiltros,
          onChange: this.cpntTabelaAlterarMPerFiltro
        },
        rpp: {
          id: this.cpntId + 'mper--rpp',
          status: '',
          nome: '',
          keyValue: 'id',
          keyMostra: [ 'id' ],
          value: { id: '10' },
          onChange: this.cpntTabelaAlterarMPerRpp
        },
        order: {
          id: this.cpntId + 'mper--order',
          status: '',
          nome: '',
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          value: '0',
          onChange: this.cpntTabelaAlterarMPerOrdencao
        },
        checkbox: []
      },
      iniciando: true
    }
  },
  mounted: function () {
    // INICIA O VALOR PARA INFORMAR QUE É A PRIMEIRA BUSCA
    this.iniciando = true

    // INICIA A TELA
    this.cpntTabelaReiniciar()
  },
  methods: {
    // cpntTabelaSetarLinhas: function (row = 0, qtde = 50) {
    //   // VERIFICA SE A QUANTIDADE É UM VALOR VALIDO
    //   if (qtde > (this.cpntLinha.length - row)) {
    //     qtde = (this.cpntLinha.length - row)
    //   }

    //   console.warn('cpntTabelaSetarLinhas', row, qtde, this.cpntLinha.length, (this.cpntLinha.length - row))
    //   // ADICIONA O VALOR DAS LINHAS
    //   // this.linhas = this.linhas.concat(JSON.parse(JSON.stringify(this.cpntLinha.slice(row, (row + qtde)))))

    //   // AGUARDA A MUTAÇÃO DA TELA
    //   this.$nextTick(() => {
    //     if (row < this.cpntLinha.length) {
    //       this.qtdeProc = (row + qtde)
    //       setTimeout(() => { this.cpntTabelaSetarLinhas((row + qtde), qtde) }, 0)
    //     }
    //   })
    // },
    cpntTabelaReiniciar: function () {
      // SETA O STATUS DE CARREGANDO DA TABELA
      this.cpntTabelaSetarStatusGeral('carregando')

      // 02-06-2022 - 11:09 - REMOVIDO BLUR, POIS ESTAVA TIRANDO O FOCUS DO PRODUTO DIGITE E SELECIONA NA EDIÇÃO DA VENDA
      // // REMOVE O FOCUS DE QUALQUER CAMPO
      // if (document.activeElement !== document.body) {
      //   document.activeElement.blur()
      // }

      // // RESETA O VALOR DAS COLUNAS
      // this.colunas = '__INICIAL__'

      // VERIFICA SE TEM ALGUM CHECKBOX PARA DESMARCAR
      if ([ '', null, undefined ].indexOf(this.cpntCheckbox) === -1 && this.cpntCheckbox.length >= 1) {
        for (var indexC in this.cpntCheckbox) {
          this.$emit('TABELA_MARCAR_CHECKBOX', false, this.cpntCheckbox[indexC])
        }
      }

      // SETA A PAGINA QUE DEVE INICIAR O PROCESSO
      this.cpntTabelaAlterarPagina({ id: '1' })
      
      // FECHA A MINHA PERSONALIZAÇÃO
      this.mostrarMPer = false

      // FECHA QUALQUER AÇÃO QUE ESTEJA ABERTA
      this.acoes = null

      // CHAMA A FUNÇÃO PARA INICIAR A TABELA
      this.cpntTabelaIniciar()
    },
    cpntTabelaIniciar: function () {
      // SETA O STATUS DE CARREGANDO DA TABELA
      this.cpntTabelaSetarStatusGeral('carregando')

      // VERIFICA SE TEM QUE BUSCAR OS REGISTROS
      if (this.cpntApiTabPer !== null && this.cpntMostrarMper === true && [ '', null, undefined ].indexOf(this.$store.state.mPer[this.cpntApiTabPer]) !== -1) {
        this.cpntTabelaBuscarValorTabPer()
      } else if (this.colunas === '__INICIAL__') {
        if (this.iniciando === true) {
          // INICIANDO O PROCESSO DE BUSCA
          this.iniciando = false
          var atualizar = true

          // INICIA O VALOR DO CAMPO
          var filtros = []

          // PEGA OS DADOS DA ROTA
          var route = this.$route

          // VERIFICA SE TEM FILTRO SELECIONADO
          if ([ '', null, undefined ].indexOf(this.$route.params.busca) === -1 && this.$route.params.busca.indexOf('menu-info') !== -1) {
            // PEGA O PARAMETRO RECEBIDO
            var busca = this.$route.params.busca.split('--')
            
            // PEGA OS DADOS DO MENU
            var itens = this.$store.state.menuInfo.filter(item => item.id === busca[1] && [ '', null, undefined ].indexOf(item.parametro) === -1)
            
            // PEGA OS REGISTROS RECEBIDOS
            if (busca.length >= 1 && [ '', null, undefined ].indexOf(itens[busca[2]]) === -1 && [ '', null, undefined ].indexOf(itens[busca[2]].parametro) === -1) {
              switch (busca[1]) {
                case '10.0.a':
                case '11.0.a':
                  filtros = [ { f: 'codigo', o: '=', v: itens[busca[2]].parametro } ]
                  break
              }

              // // REMOVE ESTE PARAMETRO, PARA NÃO BUSCAR NOVAMENTE
              // delete route.params.busca

              // // ATUALIZA A ROTA SOLICITADA
              // this.$router.replace(route)
            }
          } else if ([ '', null, undefined ].indexOf(this.$route.params.filtros) === -1) {
            // SETA OS FILTRO DO CAMPO
            filtros = Array.isArray(this.$route.params.filtros) === true ? this.$route.params.filtros : [ this.$route.params.filtros ]

            // REMOVE ESTE PARAMETRO, PARA NÃO BUSCAR NOVAMENTE
            delete route.params.filtros

            // ATUALIZA A ROTA SOLICITADA
            this.$router.replace(route)
          } else if (this.cpntApiTabPer !== null && [ '', null, undefined ].indexOf(this.$store.state.mPer[this.cpntApiTabPer]) === -1) {
            if (this.mPer.filtros.reiniciar === false) {
              // MUDA O VALOR PARA FALSE
              this.mPer.filtros.reiniciar = false

              // SETA FLAG SE DEVE OU NÃO ATUALIZAR O FILTRO
              atualizar = false
            }

            // SETA OS FILTROS PERSONALIZADOS
            filtros = this.$store.state.mPer[this.cpntApiTabPer].filtro
          }
  
          // MONTA AS COLUNAS DA TABELA
          if (atualizar === true) {
            this.cpntSetarFiltros(() => { this.cpntTabelaSetarColunas(this.cpntTabelaIniciar) }, filtros)
          } else {
            this.cpntTabelaSetarColunas(this.cpntTabelaIniciar)
          }
        } else {
          this.cpntTabelaSetarColunas(this.cpntTabelaIniciar)
        }
      } else if (this.cpntApiRouter !== null && (this.total !== '__INICIAL__' || (this.total === '__INICIAL__' && this.cpntBuscaInicial === true))) {
        this.cpntTabelaBuscarLinhas(this.pagina, this.rpp)
      } else {
        this.cpntTabelaSetarStatusGeral('')
      }
    },
    cpntTabelaSetarStatusGeral: function (status) {
      // SETA O STATUS DA TELA
      this.statusGeral = status

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // SETA O STATUS BLOQUEADO NA TABELA
      setTimeout(() => { this.cpntTabelaSetarStatusLiberado(status === '') }, 0)
    },
    cpntTabelaSetarStatusLiberado: function (value) {
      // SETA O STATUS DA TELA
      this.liberado = value

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // ENVIA O EVENTO PARA COMPONENT PAI
      this.$emit('cpntSetarStatusLiberado', value)
    },
    cpntTabelaAlterarMPerFiltro: function (value) {
      // SETA O STATUS DA TELA
      this.mPer.filtros.value = value

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    cpntTabelaAlterarMPerRpp: function (value) {
      // SETA O STATUS DA TELA
      this.mPer.rpp.value = value

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    cpntTabelaAlterarMPerOrdencao: function (value) {
      // SETA O STATUS DA TELA
      this.mPer.order.value = value

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    cpntTabelaAlterarRpp: function (value) {
      // PEGA O VALOR DO CAMPO
      var valor = typeof this.paginacao.rpp.value === "string" ? this.paginacao.rpp.value : this.paginacao.rpp.value.id

      // CONVERTE O VALOR EM NUMERO
      valor = Number(valor)

      // SETA O STATUS DA TELA
      this.paginacao.rpp.value = JSON.parse(JSON.stringify(value))

      // ATUALIZA O VALOR SELECIONADO
      this.rpp = Number(value.id)

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // VERIFICA A FUNÇÃO QUE DEVE REALIZAR
      if (valor !== this.rpp) {
        if (this.pagina !== 1) {
          this.cpntTabelaAlterarPagina({ id: '1' })
        } else {
          this.cpntTabelaBuscarLinhas(this.pagina, this.rpp)
        }
      }
    },
    cpntTabelaAlterarPaginaPassador: function (id) {
      // PEGA OS PARAMETROS RECEBIDOS
      var index = id.split('--')
      
      // VERIFIA O QUE DEVE FAZER
      if (this.statusGeral === '' && this.liberado === true) {
        // SETA O STATUS BLOQUEADO NA TABELA
        this.cpntTabelaSetarStatusLiberado(false)

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        switch (index[2]) {
          case 'anterior':
            this.cpntTabelaAlterarPagina({ id: (this.pagina - 1).toString() })
            break

          case 'proximo':
            this.cpntTabelaAlterarPagina({ id: (this.pagina + 1).toString() })
            break
        }
      }
    },
    cpntTabelaAlterarPaginaInputOnChange: function (value) {
      // SETA O STATUS DA TELA
      this.paginacao.pagina.value = value

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    cpntTabelaAlterarPaginaInputOnBlur: function () {
      if ([ '', null, undefined, 0 ].indexOf(this.paginacao.pagina.value) !== -1 || isNaN(this.paginacao.pagina.value) === true) {
        // SETA O STATUS DA TELA
        this.paginacao.pagina.value = this.pagina.toString()

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      } else {
        // PEGA O VALOR DO CAMPO
        var valor = typeof this.paginacao.pagina.value === "string" ? this.paginacao.pagina.value : this.paginacao.pagina.value.id

        // CONVERTE O VALOR EM NUMERO
        valor = Number(valor)
        
        // VERIFICA SE O VALOR É DIFERNETE
        if (valor !== this.pagina) {
          // ATUALIZA O VALOR SELECIONADO
          this.pagina = Number(valor)
    
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
    
          // CHAMA A FUNÇÃO PARA CARREGAR OS NOVOS VALORES
          this.cpntTabelaBuscarLinhas(this.pagina, this.rpp)
        }
      }
    },
    cpntTabelaAlterarPagina: function (value) {
      // PEGA O VALOR DO CAMPO
      var valor = typeof this.paginacao.pagina.value === "string" ? this.paginacao.pagina.value : this.paginacao.pagina.value.id

      // CONVERTE O VALOR EM NUMERO
      valor = Number(valor)

      // SETA O STATUS DA TELA
      this.paginacao.pagina.value = value

      // ATUALIZA O VALOR SELECIONADO
      this.pagina = Number(value.id)

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
      
      // VERIFICA SE O VALOR É DIFERNETE
      if (valor !== this.pagina) {
        // SETA O STATUS BLOQUEADO NA TABELA
        this.cpntTabelaSetarStatusLiberado(false)
        
        // REALIZA A ATULAIZAÇÃO DA TABELA
        this.cpntTabelaBuscarLinhas(this.pagina, this.rpp)
      }
    },
    cpntTabelaBuscarValorTabPer: function () {
      // REALIZA A COMUNICAÇÃO COM A API PARA PEGAR OS DADOS DA MINHA PERSONALIZAÇÃO
      this.$store.state.comunicaAPI('/config/mper/get/', 'GET', this.cpntApiTabPer, (retorno) => {
        // INICIA O VETOR DE PERSONALIZAÇÃO
        var vetor = { field: '', rpp: '10', order: '0', flag: false, filtro: '' }

        // VERIFICA SE EXISTE O FILTRO
        retorno.data.filtro = ''
        if ([ '', null, undefined ].indexOf(retorno.data.id_cg_filtro_j_filtro) === -1) {
          // CONVERTE O VALOR RECEBIDO
          retorno.data.id_cg_filtro_j_filtro.j_filtro = JSON.parse(retorno.data.id_cg_filtro_j_filtro.j_filtro)

          // PEGA O VALOR CONVERTIDO
          retorno.data.filtro = JSON.parse(JSON.stringify(retorno.data.id_cg_filtro_j_filtro))

          // DELETA O VALOR NÃO UTILIZADO MAIS
          delete retorno.data.id_cg_filtro_j_filtro
        }

        // VERIFICA SE TEM MINHA PERSONALIZAÇÃO
        var flag = Object.values(retorno.data).filter(item => [ '', null, undefined ].indexOf(item) === -1).length >= 1

        // VERIFICA SE FOI ENCONTRADO ALGUMA PERSONALIZAÇÃO
        if (flag === true) {
          vetor = retorno.data
          vetor.flag = true
        }

        // SALVA A MINHA PERSONALIZAÇÃO RECEBIDA DA API
        this.$store.commit('SET_MINHA_PERSONALIZACAO', { id: this.cpntApiTabPer, dados: vetor })

        // SETA O VALOR ATUALIZADO NA TABELA
        this.rpp = Number(vetor.rpp)

        // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
        this.cpntTabelaIniciar()
      }, this.cpntTabelaSetarStatusGeral)
    },
    cpntTabelaSetarColunas: function (callback = null) {
      // PEGA TODAS AS COLUNAS RECEBIDAS
      var colunas = JSON.parse(JSON.stringify(this.cpntColuna))
      
      // VERIFICA SE TEM QUE PERSONALIZAR ALGUMA DAS COLUNAS
      if (this.cpntApiTabPer !== null) {
        // PEGA A MINHA PERSONALIZAÇÃO EXISTENTE
        var tabper = this.$store.state.mPer[this.cpntApiTabPer]

        // VERIFICA SE TEM MINHA PERSONALIZAÇÃO
        tabper = [ '', null, undefined ].indexOf(tabper) === -1 ? tabper : { flag: false }

        // VERIFICA SE TEM PERSONALIZAÇÃO
        if (tabper.flag === true) {
          // SETA A QUANTIDADE DE REGISTROS POR PAGINA
          if (this.colunas === '__INICIAL__') {
            this.mPer.filtros.value = tabper.filtro
            this.mPer.filtros.valueIni = JSON.parse(JSON.stringify(typeof tabper.filtro === 'string' ? tabper.filtro : tabper.filtro.id))
            this.paginacao.rpp.value = { id: tabper.rpp }
            this.mPer.rpp.value = { id: tabper.rpp }
            this.rpp = Number(tabper.rpp)
          }

          // SETA A QUANTIDADE DE REGISTROS POR PAGINA
          if (this.cpntApiTabPerOrder !== null) {
            this.mPer.order.value = this.cpntApiTabPerOrder.filter(item => item.id === tabper.order)[0]
          }

          // SETA AS COLUNAS MARCADAS
          for (var indexC in colunas) {
            // OCULTA TODAS AS COLUNAS OPCIONAIS
            if (colunas[indexC].mPer === 1) {
              colunas[indexC].mPer = 0
            }

            // VERIFICA SE A COLUNA DEVE SER APRESENTADA
            if (colunas[indexC].mPer === 0 && tabper.field.indexOf(colunas[indexC].chave) !== -1) {
              colunas[indexC].mPer = 1
            }
          }
        }
      }

      // SETA O VALOR CALCULADO
      this.colunas = colunas

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // EXECUTA A FUNÇÃO CALLBACK
      if (callback !== null && typeof callback === 'function') {
        callback()
      }
    },
    cpntTabelaMontarQueryGetAdicionarWhere: function (queryGetW, vetor) {
      // INICIA O VALOR DA CHAVE WHERE
      if ([ '', null, undefined ].indexOf(queryGetW) !== -1) {
        queryGetW = { aAnd: [] }
      } else if ([ '', null, undefined ].indexOf(queryGetW.aAnd) !== -1) {
        queryGetW = { aAnd: [ ] }
      }

      // ADICIONA O VALOR AO VETOR
      if (Array.isArray(vetor) === true) {
        queryGetW.aAnd = queryGetW.aAnd.concat(vetor)
      } else {
        queryGetW.aAnd.push(vetor)
      }

      // RETORNA O VALOR MONTADO
      return queryGetW
    },
    cpntTabelaMontarQueryGetWhere: function (callback, queryGet, where, indexW = 0) {
      if ([ '', null, undefined ].indexOf(where[indexW]) !== -1) {
        // REMOVE A CHAVE WHERE SE ELA NÃO TIVER VALOR
        if ([ '', null, undefined ].indexOf(queryGet.where) === -1 && Object.keys(queryGet.where).length === 0) {
          delete queryGet.where
        }

        // EXECUTA O CALLBACK RECEBIDO
        callback(queryGet)
      } else {
        // PROCURA A PRIMEIRA CHAVE WHERE NA ESTRUTURA
        var indexWE = this.cpntApiEstruturaQueryGet.findIndex(item => item.indexOf('where') !== -1)

        // VERIFICA SE EXITE A CHAVE
        if (indexWE === -1) {
          this.cpntTabelaSetarStatusGeral({ loc: 'WEB', cod: '500', err: 'Não encontrado chave para preencher o where na estrutura da tabela.' })
        } else {
          // PEGA O RETORNO DA FUNÇÃO
          var retorno = this.cpntMontarWhere(where[indexW])

          // VERIFICA SE TEM ALGUM VALOR RECEBIDO
          if (([ '', null, undefined ].indexOf(retorno) !== -1 || Object.keys(retorno).length === 0) || Object.keys(retorno).length === 1 && Object.keys(retorno).indexOf('fazerOrdenacao') !== -1) {
            retorno = { where: where[indexW] }
          }

          // SETA O WHERE NO NIVEL INFORMADO
          switch (indexWE) {
            case 0:
              queryGet.where = this.cpntTabelaMontarQueryGetAdicionarWhere(queryGet.where, retorno.where)
              break

            case 1:
              queryGet.from.where = this.cpntTabelaMontarQueryGetAdicionarWhere(queryGet.from.where, retorno.where)
              break
          }

          // VERIFICA SE TEM JW PARA SER INCLUIDO
          if ([ '', null, undefined ].indexOf(retorno.jw) === -1) {
            // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
            const FUN_VETOR_MERGE = require('@/assets/js/Funcoes-Gerais.js').FUN_VETOR_MERGE

            // JUNTA OS DOIS VETORES
            if ([ '', null, undefined ].indexOf(retorno.jw[0]) === -1 && Object.keys(retorno.jw[0]).length >= 1) {
              queryGet.field = FUN_VETOR_MERGE(queryGet.field, retorno.jw[0])
            }
            if ([ '', null, undefined ].indexOf(retorno.jw[1]) === -1 && Object.keys(retorno.jw[1]).length >= 1) {
              queryGet.from.field = FUN_VETOR_MERGE(queryGet.from.field, retorno.jw[1])
            }
          }

          // VERIFICA SE TEM JW PARA SER INCLUIDO
          if ([ '', null, undefined ].indexOf(retorno.config) === -1) {
            // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
            const FUN_VETOR_MERGE = require('@/assets/js/Funcoes-Gerais.js').FUN_VETOR_MERGE

            // JUNTA OS DOIS VETORES
            if ([ '', null, undefined ].indexOf(retorno.config[0]) === -1 && Object.keys(retorno.config[0]).length >= 1) {
              queryGet = FUN_VETOR_MERGE(queryGet, retorno.config[0])
            }
            if ([ '', null, undefined ].indexOf(retorno.config[1]) === -1 && Object.keys(retorno.config[1]).length >= 1) {
              queryGet.from = FUN_VETOR_MERGE(queryGet.from, retorno.config[1])
            }
          }

          // VERIFICA SE TEM QUE REMOVER A ORDENAÇÃO DA QUERY
          if ([ '', null, undefined ].indexOf(retorno.fazerOrdenacao) === -1 && retorno.fazerOrdenacao !== true) {
            // REMOVE O VALOR DO CAMPO
            delete queryGet.order

            // SETA O FLAG
            this.fazerOrdenacao = false
          }

          // REINICIA O PROCESSO PARA ADICIONAR O PROXIMO FILTRO
          this.cpntTabelaMontarQueryGetWhere(callback, queryGet, where, (indexW + 1))
        }
      }
    },
    cpntTabelaMontarQueryGet: function (callback, limit = null, where = [], contador = 0, queryGet = null) {
      if (this.cpntApiEstruturaQueryGet === null) {
        callback(queryGet)
      } else {
        // SETA O VALOR INICIAL DA VARIAVEL
        if (queryGet === null) {
          queryGet = {}
        }
        
        // MONTA A PROMISE
        new Promise((successMQ) => {
          if ([ '', null, undefined ].indexOf(this.cpntApiMontarQueryGet) === -1 && typeof this.cpntApiMontarQueryGet === 'function') {
            callback(queryGet)
          } else {
            // PEGA O NUMERO DO FROM QUE DEVE MONTAR
            var index = (this.cpntApiEstruturaQueryGet.length - 1) - contador
            
            // VERIFICA SE TEM MAIS ITENS A BUSCAR
            if (index < 0) {
              this.cpntTabelaMontarQueryGetWhere(callback, queryGet, where)
            } else {
              if (Object.keys(queryGet).length >= 1) {
                queryGet = { from: queryGet }
              }
    
              // INICIA A BUSCA DE DADOS
              if (this.cpntApiEstruturaQueryGet[index].indexOf('type') !== -1) {
                queryGet.type = 'list'
              }
        
              // VERIFICA SE EXISTE PAGINAÇÃO
              if (this.cpntApiEstruturaQueryGet[index].indexOf('limit') !== -1 && this.cpntApiEstruturaQueryGet[index].indexOf('SemPaginacao') !== -1) {
                queryGet.limit = { row: 0, qty: 1000 }
              } else if (this.cpntApiEstruturaQueryGet[index].indexOf('limit') !== -1) {
                queryGet.limit = limit
              }
    
              // VERIFICA SE EXISTE PAGINAÇÃO
              if (this.cpntApiEstruturaQueryGet[index].indexOf('countAll') !== -1) {
                queryGet.countAll = null
              }
    
              // VERIFICA SE TEM QUE COLOCAR O ORDER
              if (this.cpntApiEstruturaQueryGet[index].indexOf('field') !== -1) {
                // VERIFICA SE DEVE INFORMAR FIELD VIRTUAL
                if (this.cpntApiEstruturaQueryGet[index].indexOf('field_virtual') !== -1) {
                  queryGet.field_virtual = ([ '', null, undefined ].indexOf(this.cpntApiFieldVirtual) === -1 ? this.cpntApiFieldVirtual : [])
                }
    
                // SETA OS CAMPOS QUE DEVEM RETORNAR
                queryGet.field = ([ '', null, undefined ].indexOf(this.cpntApiField) === -1 ? this.cpntApiField : {})
        
                // RODA O VETOR ADICIONANDO AS COLUNAS
                for (var indexC in this.colunas) {
                  if ([ '', null, undefined ].indexOf(this.cpntApiField) === -1 || this.colunas[indexC].mPer >= 1) {
                    if (this.colunas[indexC].fieldsApi !== undefined) {
                      // CONVERTE O VALOR DA COLUNA PARA ARRAY
                      if (Array.isArray(this.colunas[indexC].fieldsApi) === false) {
                        this.colunas[indexC].fieldsApi = [ this.colunas[indexC].fieldsApi ]
                      }
      
                      // VERIFICA SE TEM COLUNA PARA BUSCAR NA API
                      if (this.colunas[indexC].fieldsApi[index] !== undefined) {
                        queryGet.field = Object.assign(queryGet.field, this.colunas[indexC].fieldsApi[index])
                      }
                    }
      
                    // SETA OS FIELDS VIRTUAIS QUE DEVE BUSCAR
                    if (queryGet.field_virtual !== undefined && this.colunas[indexC].fieldsVir !== undefined) {
                      queryGet.field_virtual = queryGet.field_virtual.concat(Array.isArray(this.colunas[indexC].fieldsVir[index]) === true ? this.colunas[indexC].fieldsVir[index] : this.colunas[indexC].fieldsVir)
                    }
                  }
                }
    
                // REMOVE OS CAMPOS DUPLICADOS
                if (queryGet.field_virtual !== undefined) {
                  queryGet.field_virtual = queryGet.field_virtual.filter((v, i, a) => a.indexOf(v) === i)
                }
              }
    
              // VERIFICA SE TEM QUE COLOCAR O ORDER
              if (this.cpntApiEstruturaQueryGet[index].indexOf('order') !== -1 && ([ '', null, undefined ].indexOf(this.cpntApiTabPerOrder) === -1 || [ '', null, undefined ].indexOf(this.cpntApiOrder) === -1)) {
                // INICIA O ORDER
                queryGet.order = JSON.parse(JSON.stringify(this.cpntApiOrder))
    
                // VERIFICA SE TEM ORDENAÇÃO PERSONALIZADA
                if (this.cpntApiTabPerOrder !== null && this.cpntApiEstruturaQueryGet[index].indexOf('order') !== -1 && this.cpntApiEstruturaQueryGet[index].indexOf('sem_order_mper') === -1) {
                  // PEGA A MINHA PERSONALIZAÇÃO EXISTENTE
                  var tabper = this.$store.state.mPer[this.cpntApiTabPer]
      
                  // VERIFICA SE TEM MINHA PERSONALIZAÇÃO
                  tabper = [ '', null, undefined ].indexOf(tabper) === -1 ? tabper : { flag: false }
      
                  // PEGA A ORDENAÇÃO QUE DEVE REALIZAR
                  var vetor = this.cpntApiTabPerOrder.length >= 1 ? [ this.cpntApiTabPerOrder[0] ] : []
      
                  // PEGA A ORDENAÇÃO QUE DEVE REALIZAR
                  if (tabper.flag === true) {
                    vetor = this.cpntApiTabPerOrder.filter(item => item.id === tabper.order)
                  }
      
                  // VERIFICA SE FOI ENCONTRADO O ORDER
                  if (vetor.length >= 1) {
                    queryGet.order[vetor[0].chave] = [ '', null, undefined ].indexOf(vetor[0].operacao) === -1 ? { o: vetor[0].operacao, d: vetor[0].order } : vetor[0].order
                  }
                }
              }
        
              // REMOVE O FIELD SE NÃO TIVER INFORMAÇÃO DE CAMPO
              if ([ '', null, undefined ].indexOf(queryGet.field) !== -1 || Object.keys(queryGet.field).length === 0) {
                  delete queryGet.field
              }
        
              // REMOVE O ORDER SE NÃO TIVER INFORMAÇÃO DE CAMPO
              if ([ '', null, undefined ].indexOf(queryGet.order) !== -1 || Object.keys(queryGet.order).length === 0) {
                  delete queryGet.order
              }
        
              // SETA O WHERE QUE DEVE REALIZAR
              if (this.cpntApiWhere !== null) {
                // PEGA O VALOR RECEBIDO
                var whereIni = JSON.parse(JSON.stringify(this.cpntApiWhere))
    
                // CONVERTE O VALOR DO WHERE PARA ARRAY
                if (Array.isArray(whereIni) === false) {
                  whereIni = [ whereIni ]
                }
    
                // ADICIONA O WHERE RECEBIDO
                if (whereIni[index] !== null) {
                  queryGet.where = whereIni[index]
                }
              }
    
              // VERIFICA SE TEM WHERE PARA TRATAR
              if ([ '', null, undefined ].indexOf(where) !== -1) {
                where = []
              }
    
              // PEGA OS WHERE DOS CAMPOS
              var whereN = where.filter(item => item.nivelW === index.toString() && item.where === true)
    
              // VERIFICA SE TEM WHERE PARA SETAR
              if (whereN.length >= 1) {
                // VERIFICA SE DEVE INICIAR O VALOR
                if ([ '', null, undefined ].indexOf(queryGet.where) !== -1) {
                  queryGet.where = { aAnd: [] }
                } else if ([ '', null, undefined ].indexOf(queryGet.where.aAnd) !== -1) {
                  queryGet.where = { aAnd: [ queryGet.where ] }
                }
        
                // SETA OS WHERES NOS NIVEIS
                for (var indexWN in whereN) {
                  switch (whereN[indexWN].whereTP) {
                    case 'aOr':
                    case 'aAnd':
                      // INICIA A VARIAVEL
                      var agrupado = []
    
                      // PEGA TODOSO OS VALORES ENCONTRADOS
                      for (var indexWNA in whereN[indexWN].fields) {
                        agrupado = agrupado.concat(whereN[indexWN].fields[indexWNA].where)
                      }
    
                      // PEGA O NUMERO DA CHAVE QUE VAI SETAR O AGRUPADO
                      var indexA = queryGet.where.aAnd.length
                      
                      // SETA O VALOR AGRUPADO
                      queryGet.where.aAnd[indexA] = {}
                      queryGet.where.aAnd[indexA][whereN[indexWN].whereTP] = agrupado
                      break
    
                    default: 
                      for (var indexWNF in whereN[indexWN].fields) {
                        queryGet.where.aAnd = queryGet.where.aAnd.concat(whereN[indexWN].fields[indexWNF].where)
                      }
                    break
                  }
                }
              }
    
              // SETA O GROUP QUE DEVE REALIZAR
              if (this.cpntApiGroup !== null && this.cpntApiGroup[index] !== null) {
                queryGet.group = this.cpntApiGroup[index]
              }
    
              // CHAMA A FUNÇÃO PARA REINICIAR A MONTAGEM
              successMQ(queryGet)
            }
          }
        }).then((query) => {
          this.cpntTabelaMontarQueryGet(callback, limit, where, (contador + 1), JSON.parse(JSON.stringify(query)))
        })
      }
    },
    cpntTabelaBuscarLinhas: function (pag = 1, rpp = 10) {
      // SETA O FLAG
      this.fazerOrdenacao = true

      // SETA O STATUS BLOQUEADO NA TABELA
      this.cpntTabelaSetarStatusLiberado(false)

      // MONTA O WHERE DA PESQUISA
      this.cpntMontarFiltros((filtros, filtroDiff) => {
        if (filtros === 'ERRO_FILTRO') {
          this.cpntTabelaSetarStatusGeral('')
        } else if (filtroDiff === true && this.pagina !== 1) {
          this.cpntTabelaAlterarPagina({ id: '1' })
        } else {
          // SETA O FILTRO RECEBIDO
          this.filtros = filtros

          // SETA O LIMITE PARA BUSCA
          var limit = { row: ((pag * rpp) - rpp), qty: rpp }

          new Promise((successQ) => {
            if ([ '', null, undefined ].indexOf(this.cpntApiMontarQueryGet) === -1 && typeof this.cpntApiMontarQueryGet === 'function') {
              // CARREGA OS DADOS DO CAMPO
              var query = this.cpntApiMontarQueryGet(pag, rpp, null)
              
              // VERIFICA SE O RETORNO É UM PROMISSE OU NÃO
              if (typeof query === 'object' && typeof query.then === 'function') {
                query.then((retQuery) => { successQ(retQuery) })
              } else {
                successQ(query)
              }
            } else {
              successQ(null)
            }
          }).then((params) => {
            this.cpntTabelaMontarQueryGet((queryGet) => { this.cpntTabelaBuscarLinhasApi(queryGet) }, limit, filtros, 0, params)
          })
          // cpntTabelaMontarQueryGet: function (callback, limit = null, where = [], contador = 0, queryGet = null) {

          // CHAMA FUNÇÃO PARA MONTAR O QUERY GET

          // // CARREGA AS COLUNAS QUE DEVE APRESENTAR
          // this.cpntTabelaSetarColunas(() => {
          //   // SETA O LIMITE PARA BUSCA
          //   var limit = { row: ((pag * rpp) - rpp), qty: rpp }

          //   // CHAMA FUNÇÃO PARA MONTAR O QUERY GET
          //   this.cpntTabelaMontarQueryGet((queryGet) => { this.cpntTabelaBuscarLinhasApi(queryGet) }, limit, filtros)
          // })
        }
      })
    },
    cpntTabelaBuscarLinhasApi: function (queryGet, registros = []) {
      // VERIFICA SE TEM PAGINAÇÃO A SER FEITA NA PESQUISA
      var semPaginacao = this.cpntApiEstruturaQueryGet.filter(array => array.indexOf('SemPaginacao') !== -1).length >= 1

      // VERIFICA SE DEVE BUSCAR TODOS OS REGISTROS DA TABELA DE 1000 EM 1000
      if (semPaginacao === true && [ '', null, undefined ].indexOf(queryGet.limit) === -1) {
        queryGet.limit = { row: registros.length, qty: 1000 }
      }

      // queryGet.return = 'mysqlQuery'
      // delete queryGet.field_virtual

      // FAZ A BUSCA DOS DADOS NA API
      this.$store.state.comunicaAPI(this.cpntApiRouter, this.cpntApiMethods, queryGet, (retorno) => {
        if (queryGet.return === 'mysqlQuery') {
          // eslint-disable-next-line
          console.log(queryGet, retorno.data.mysqlQuery)

          // APRSENTA MENSAGEM NA TELA
          this.$store.commit('FUN_COPIAR_VALOR', { valor: retorno.data.mysqlQuery, mensagem: 'WEB [200]: SQL gerado e copiado para a área de transferência.' })

          // SETA O STATUS DE CARREGANDO DA TABELA PARA FICAR TRAVADA
          this.cpntTabelaSetarStatusGeral('carregando')
        } else {
          // JUNTA OS VALORES RECEBIDOS
          registros = registros.concat(retorno.data)

          // VERIFICA SE TEM QUE BUSCAR MAIS REGISTROS
          if (semPaginacao === true && [ '', null, undefined ].indexOf(queryGet.limit) === -1 && Number(retorno.countAll) > registros.length) {
            setTimeout(() => { this.cpntTabelaBuscarLinhasApi(queryGet, registros) }, 500)
          } else {
            this.cpntApiBuscaComplementar(registros, (_dados) => {
              // SETA O TOTAL DE REGISTROS ENCONTRADOS
              if ([ '', null, undefined ].indexOf(retorno.countAll) === -1 && semPaginacao === false) {
                this.total = Number(retorno.countAll)
              }
    
              // SETA O RETORNO RECEBIDO
              this.cpntSetarValores(_dados)
              
              // CHAMA A FUNÇÃO PARA CALCULAR A QUANTIDADE DE REGISTROS
              this.cpntApiTabCalcularQtdeRegistros()
    
              // SETA O STATUS DE CARREGANDO DA TABELA
              this.cpntTabelaSetarStatusGeral('')
    
              // SETA O STATUS BLOQUEADO NA TABELA
              setTimeout(() => { this.cpntTabelaSetarStatusLiberado(true) }, 0)
            }, retorno)
          }
        }
      }, this.cpntTabelaSetarStatusGeral, (apiValid, apiStatus) => {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // CHAMA A FUNÇÃO PARA TRATAR O ERRO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus)
      })
    },
    cpntApiTabCalcularQtdeRegistros: function () {
      if (this.total <= 0) {
        // SETA O NUMERO DO REGISTRO INICIAL
        this.regIni = 0

        // SETA O NUMERO DO REGISTRO FINAL
        this.regFim = 0

        // SETA A QUANTIDADE DE PAGINAS
        this.qtdePag = 1
      } else {
        // SETA A QUANTIDADE DE PAGINAS
        this.qtdePag = Math.ceil(this.total / this.rpp)

        // VERIFICA O NUMERO INICIAL DO REGISTRO
        this.regIni = this.pagina === 1 ? 1 : ((this.pagina * this.rpp) - this.rpp)

        // SETA O NUMERO DO ULTIMO REGISTRO
        if (this.pagina === 1 && this.rpp <= Number(this.total)) {
          this.regFim = this.rpp
        } else if (this.pagina === this.qtdePag) {
          this.regFim = this.total
        } else if (this.pagina === this.qtdePag && this.rpp <= this.total) {
          this.regFim = (this.total - this.rpp) + this.rpp
        } else {
          this.regFim = (this.pagina * this.rpp)
        }
      }

      // CHAMA A FUNÇÃO PARA SETAR OS OPTIONS 
      this.cpntTabelaSetarOptionsPaginacao()
    },
    cpntTabelaSetarOptionsPaginacao: function () {
      // INICIA OS OPTIONS
      var options = []
      
      // GERA OS OPTIONS DA PAGINAÇÃO
      for (var i = 1; i <= this.qtdePag; i++) {
        options.push({ id: i.toString() })
      }

      // SETA OS OPTIONS 
      this.paginacao.pagina.options = options
    },
    cpntTabelaImprimir: function () {
      $(this.$refs.tabela).printElement()
    },
    cpntTabelaMPerCheckboxSelecionarTodos: function () {
      // INICIA A VARIAVEL
      var checkbox = []

      // MONTA A VARIAVEL QUE VAI MOSTRAR TODAS AS COLUNAS
      for (var indexC1 in this.colunas) {
        if (this.colunas[indexC1].mPer >= 0 && this.colunas[indexC1].mPer <= 2) {
          checkbox.push(this.colunas[indexC1].chave)
        }
      }

      // SETA TODAS AS COLUNAS QUE DEVE MOSTRAR
      this.mPer.checkbox = checkbox

      // MONTA A VARIAVEL QUE VAI MOSTRAR TODAS AS COLUNAS
      for (var indexC2 in this.colunas) {
        if (this.colunas[indexC2].mPer === 0 && checkbox.indexOf(this.colunas[indexC2].chave) !== -1) {
          this.colunas[indexC2].mPer = 1
        }
      }
      
      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // APRESENTA A MENSAGEM DE ERRO
      this.$store.state.msgWarn('WEB [200]: Todas as colunas estão sendo exibidas na tabela.', 'success')

      // MANDA FECHAR A TELA
      this.cpntTabelaMostrarMPer({ type: 'click' })
    },
    cpntTabelaMPerCheckboxOnChange: function (event) {
      // PEGA O NOME DA COLUNA
      var coluna = event.target.id.split('--')[1]

      // VERIFICA A AÇÃO QUE DEVE REALIZAR COM OS CHECKBOXS
      switch (event.target.checked) {
        case true:
          this.mPer.checkbox.push(event.target.value)
          break

        case false:
          this.mPer.checkbox = this.mPer.checkbox.filter(item => item !== event.target.value)
          break
      }

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
      
      // VERIFICA SE TEM MINHA PERSONALIZAÇÃO
      if (this.cpntApiTabPer === null) {
        // PEGA O INDEX DA COLUNA
        var indexC = this.colunas.findIndex(item => item.chave === coluna)

        // VERIFICA SE A COLUNA DEVE MOSTRAR OU NÃO
        this.colunas[indexC].mPer = this.colunas[indexC].mPer === 0 ? 1 : 0
      }
    },
    cpntTabelaMostrarMPer: function (event) {
      if (event.type === 'click') {
        // OCULTA E MOSTRA TELA DE MINHA PERSONALIZAÇÃO
        this.mostrarMPer = !this.mostrarMPer

        // SETA OS VALORES MARCADOS
        if (this.mostrarMPer === true) {
          // LIMPA A VARIAVEL DE CHECKBOX
          this.mPer.checkbox = []

          // RODA O VETOR EM TODAS AS COLUNAS
          for (var indexC in this.colunas) {
            if ([ '', null, undefined ].indexOf(this.colunas[indexC].chave) === -1 && this.colunas[indexC].mPer >= 1 && this.colunas[indexC].mPer <= 2) {
              this.mPer.checkbox.push(this.colunas[indexC].chave)
            }
          }
        }
      }
    },
    cpntTabelaSalvarMPer: function () {
      // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
      var formData = { model: this.cpntApiTabPer, rpp: '', order: '', ac: '', field: '' }

      // VERIFICA SE TEM FIELDS PARA SALVAR
      formData.field = this.mPer.checkbox.join(',')
      
      // SETA A ORDENAÇÃO DOS CAMPOS
      formData.order = this.mPer.order.value

      // SETA A ORDENAÇÃO DOS CAMPOS
      formData.rpp = this.mPer.rpp.value

      // SETA A ORDENAÇÃO DOS CAMPOS
      formData.id_cg_filtro = this.mPer.filtros.value

      // VERIFICA SE É OBJETO, CONVERTE EM STRING
      formData.id_cg_filtro = typeof formData.id_cg_filtro === 'string' ? formData.id_cg_filtro : formData.id_cg_filtro.id
      formData.order = typeof formData.order === 'string' ? formData.order : formData.order.id
      formData.rpp = typeof formData.rpp === 'string' ? formData.rpp : formData.rpp.id

      // VERIFICA SE DEVE REALIZAR OS FILTROS
      this.mPer.filtros.reiniciar = (formData.id_cg_filtro !== this.mPer.filtros.valueIni)

      // REALIZA A COMUNICAÇÃO COM A API
      this.$store.state.comunicaAPI('/config/mper', 'PUT', formData, (retorno) => {
        // APRESENTA A MENSAGEM RETORNADA DA API
        this.$store.state.TRATAR_RET_LOT_API(retorno)

        // REMOVE MINHA PERSONALIZAÇÃO SALVA
        this.$store.commit('REMOVE_MINHA_PERSONALIZACAO', this.cpntApiTabPer)

        // RESETA O VALOR DAS COLUNAS
        this.colunas = '__INICIAL__'

        // MANDA REALIZAR A BUSCA
        this.$emit('BUSCAR')

        // LIMPA O FLAG PARA SETAR O FILTRO NOVAMENTE NA TABELA
        this.iniciando = true

        // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
        this.cpntTabelaReiniciar()
      }, this.cpntTabelaSetarStatusGeral)
    },
    cpntTabelaMPerBuscarFiltros: function (callback) {
      // INICIA O QUERYGET
      var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null, j_filtro: null } }

      // SETA O WHERE DO REQUEST
      queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'ref_front_end', o: '=', v: this.cpntApiTabPer } ] }

      // VERIFICA SE TEM ALGUM VALOR SELECIONADO
      if ([ '', null, undefined ].indexOf(this.mPer.filtros.value) === -1) {
        // PEGA O VALOR QUE DEVE PREENCHER NO WHERE
        var valor = typeof this.mPer.filtros.value === 'string' ? this.mPer.filtros.value : this.mPer.filtros.value.id
        
        // SETA O VALOR QUE DEVE BUSCAR
        queryGet.where.aAnd[0] = { aOr: [
          { f: 'id', o: '=', v: valor },
          { f: 'status', o: '=', v: '1' }
        ] }
      }

      // REALIZA A COMUNICAÇÃO COM A API
      this.$store.state.comunicaAPI('/config/filtro/get', 'POST', queryGet, (retorno) => {
        // SETA OS VALORES RECEBIDOS
        this.mPer.filtros.options = retorno.data

        // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
        callback()
      }, this.cpntTabelaSetarStatusGeral)
    },
    cpntTabelaAcaoExportarSetarStatus: function (formato, status) {
      // SETA O STATUS RECEBIDO NO CAMPO
      switch (formato) {
        case 'xlsx':
          this.botaoExportarXLSXStatus = status
          break

        case 'pdf':
          this.botaoExportarPDFStatus = status
          break

        case 'exportar':
          this.exportarStatus = status
          break
      }

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    cpntTabelaAcaoExportar: function (formato, pagina = 1) {
      if (this.filtros !== 'ERRO_FILTRO') {
        // SETA O STATUS DO BOTÃO
        this.cpntTabelaAcaoExportarSetarStatus(formato, 'carregando')
        this.cpntTabelaAcaoExportarSetarStatus('exportar', 'carregando')

        // REMOVE A URL QUE NÃO SERÁ MAIS UTILZIADA
        // setTimeout(() => { this.cpntTabelaAcaoExportarSetarStatus(formato, '') }, 2000)

        // SETA O LIMITE PARA BUSCA
        var limit = { row: ((this.pagina * this.rpp) - this.rpp), qty: this.rpp }

        // VERIFICA SE TEM QUE MONTAR OS FILTROS
        new Promise((successF) => {
          // INICIA A VARIAVEL
          var retornoF = ''

          // VERIFICA SE EXISTE O FILTRO
          if ([ '', null, undefined ].indexOf(this.cpntFiltros) === -1 && typeof this.cpntFiltros.cpntFiltroNomesRelatorio === 'function') {
            // CARREGA OS DADOS DO CAMPO
            retornoF = this.cpntFiltros.cpntFiltroNomesRelatorio()
            
            // VERIFICA SE O RETORNO É UM PROMISSE OU NÃO
            if (typeof retornoF === 'object' && typeof retornoF.then === 'function') {
              retornoF.then((retF) => { successF(retF) })
            } else {
              successF(retornoF)
            }
          } else if ([ '', null, undefined ].indexOf(this.cpntMontarFiltroRelatorio) === -1 && typeof this.cpntMontarFiltroRelatorio === 'function') {
            // CARREGA OS DADOS DO CAMPO
            retornoF = this.cpntMontarFiltroRelatorio()
            
            // VERIFICA SE O RETORNO É UM PROMISSE OU NÃO
            if (typeof retornoF === 'object' && typeof retornoF.then === 'function') {
              retornoF.then((retF) => { successF(retF) })
            } else {
              successF(retornoF)
            }
          } else {
            successF(this.filtros)
          }
        }).then((_filtros) => {
          new Promise((successQ) => {
            if ([ '', null, undefined ].indexOf(this.cpntApiMontarQueryGet) === -1 && typeof this.cpntApiMontarQueryGet === 'function') {
              // CARREGA OS DADOS DO CAMPO
              var query = this.cpntApiMontarQueryGet(this.pagina, this.rpp, { tipo: formato, pagina: pagina })
              
              // VERIFICA SE O RETORNO É UM PROMISSE OU NÃO
              if (typeof query === 'object' && typeof query.then === 'function') {
                query.then((retQuery) => { successQ(retQuery) })
              } else {
                successQ(query)
              }
            } else {
              // CHAMA FUNÇÃO PARA MONTAR O QUERY GET
              this.cpntTabelaMontarQueryGet((queryGet) => { successQ(queryGet) }, limit, this.filtros)
            }
          }).then((params) => {
            // SETA O FORMATO QUE SERÁ UTILIZADO
            params.export = { format: formato, field: {}, search: _filtros, page: pagina }

            // VERIFICA SE A VARIAVEL TEM UM VALOR VALIDO
            if ([ '', null, undefined ].indexOf(params.export.search) !== -1 || params.export.search.length === 0) {
              params.export.search = ''
            }

            // INICIA A VARIAVEL FIELD
            var fields = {}

            // VERIFICA SE TEM A CHAVE FIELD PARA TRABALHAR
            if ([ '', null, undefined ].indexOf(this.cpntBotaoExportar.field) === -1) {
              if ([ '', null, undefined ].indexOf(this.cpntBotaoExportar) === -1 && [ '', null, undefined ].indexOf(this.cpntBotaoExportar.field) === -1) {
                fields = JSON.parse(JSON.stringify(this.cpntBotaoExportar.field))
              }

              // RODA O VETOR CONVERTENDO OS VALORES
              for (var indexF in fields) {
                
                // INICIA A VARIAVEL QUE VAI RECEBER A COLUNA NO DOCUMENTO
                var item = fields[indexF]

                // VERIFICA SE É UM VALOR QUE DEVE PEGAR DA COLUNA
                // if (typeof fields[indexF] === 'string') {
                //   console.log(fields[indexF])
                // }

                // VERIFICA SE PRECISA CONVERTER O VALOR
                if (typeof item[Object.keys(item)[0]] === 'string') {
                  item[Object.keys(item)[0]] = { a: item[Object.keys(item)[0]] }
                }
                
                // JUNTA OS VALORES RECEBIDOS
                params.export.field = Object.assign(params.export.field, item)
              }
            } else {
              for (var indexC in this.colunas) {
                if (this.colunas[indexC].mPer >= 1) {
                  // VERIFICA COMO DEVE ADICIONAR O CAMPO PARA EXPORTAÇÃO
                  if ([ '', null, undefined ].indexOf(this.colunas[indexC].export) === -1 && [ '', null, undefined ].indexOf(this.colunas[indexC].export.fields) === -1 && Object.keys(this.colunas[indexC].export.fields).length >= 1) {
                    fields = Object.assign(fields, this.colunas[indexC].export.fields)
                  } else if ([ '', null, undefined ].indexOf(this.colunas[indexC].chave) === -1 && [ '', null, undefined ].indexOf(this.colunas[indexC].nome) === -1) {
                    fields[this.colunas[indexC].chave] = this.colunas[indexC].nome
                  }
                }
              }

              // CONVERTE OS CAMPOS
              for (var indexF1 in fields) {
                if (typeof fields[indexF1] === 'string') {
                  fields[indexF1] = { a: fields[indexF1] }
                }
              }

              // JUNTA OS VALORES RECEBIDOS
              params.export.field = fields
            }

            // FAZ A BUSCA DOS DADOS NA API
            this.$store.state.comunicaAPI(this.cpntApiRouter, this.cpntApiMethods, params, (retorno) => {
              this.cpntTabelaAcaoExportarReceberArquivo(formato, retorno)
            }, (retorno) => {
              this.cpntTabelaAcaoExportarReceberArquivo(formato, retorno)
            }, (retorno) => {
              this.cpntTabelaAcaoExportarReceberArquivo(formato, retorno)
            })
          })
        })
      }
    },
    cpntTabelaAcaoExportarReceberArquivo: function (formato, retorno) {
      if ([ '', null, undefined ].indexOf(retorno) !== -1 || [ '', null, undefined ].indexOf(retorno.data) !== -1 || [ '', null, undefined ].indexOf(retorno.data.filename) !== -1 || [ '', null, undefined ].indexOf(retorno.data.string) !== -1) {
        // SETA O STATUS DO BOTÃO
        this.cpntTabelaAcaoExportarSetarStatus(formato, '')

        // APRESENTA A MENSAGEM DE ERRO
        if (retorno.geralWeb !== undefined) {
          this.$store.state.msgWarn('API [500]: ' + retorno.geralWeb, 'danger')
        } else {
          this.$store.state.msgWarn('WEB [500]: Não foi possivel gerar este arquivo, por favor tente novamente mais tarde.', 'danger')
        }
      } else {
        // DECODIFICAR A SEQUÊNCIA BASE64, REMOVER ESPAÇO PARA COMPATIBILIDADE COM O IE
        // DESCRIPTOGRAFA O B64 PARA RESOLVER PROBLEMA DO IE
        var binary = atob(retorno.data.string.replace(/\s/g, ''))
        var len = binary.length
        var buffer = new ArrayBuffer(len)
        var view = new Uint8Array(buffer)
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i)
        }

        // PEGA O MINETYPE DO ARQUIVO
        var minetype = ''
        switch (formato) {
          case 'xlsx':
            minetype = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            break

          case 'pdf':
            minetype = 'application/pdf'
            break
        }

        // CRIE O OBJETO BLOB COM O CONTENT-TYPE "APPLICATION/PDF"
        var blob = new Blob([ view ], { type: minetype })

        // MONTA O BOTÃO OCULTO PARA DORNWLOAD DO ARQUIVO
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        a.download = retorno.data.filename

        // ADICIONA O BOTÃO NA TELA DO USUARIO DE FORMA OCULTA
        document.body.appendChild(a)

        // REALIZA O CLICK PARA FAZER O DOWNLOAD DO ARQUIVO
        a.click()

        // SETA O STATUS DO BOTÃO
        this.cpntTabelaAcaoExportarSetarStatus(formato, '')

        // REMOVE A URL QUE NÃO SERÁ MAIS UTILZIADA
        setTimeout(() => {
          // REMOVE A URL QUE NÃO SERÁ MAIS UTILZIADA
          window.URL.revokeObjectURL(url)

          // REMOVE O BOTÃO DA TELA
          a.remove()
        }, 2000)

        // CONVERTE EM NUMERO OS VALORES RECEBIDOS
        if ([ '', null, undefined ].indexOf(retorno.data.next_page) === -1) {
          retorno.data.next_page = Number(retorno.data.next_page)
        }
        if ([ '', null, undefined ].indexOf(retorno.data.total_page) === -1) {
          retorno.data.total_page = Number(retorno.data.total_page)
        }

        // VERIFICA SE TEM MAIS PAGINAS A SEREM BAIXADAS
        if ([ '', null, undefined ].indexOf(retorno.data.next_page) !== -1 || [ '', null, undefined ].indexOf(retorno.data.total_page) !== -1) {
          this.cpntTabelaAcaoExportarFecharDialog()
        } else if (retorno.data.next_page <= retorno.data.total_page) {
          // SETA O VALOR PARA ABRIR PAGINAÇÃO
          this.exportarPagina = { atual: (retorno.data.next_page - 1), proxima: retorno.data.next_page, total: retorno.data.total_page, formato: formato }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      }

      // SETA O STATUS DA PAGINA
      this.cpntTabelaAcaoExportarSetarStatus('exportar', '')
    },
    cpntTabelaAcaoExportarFecharDialog: function () {
      // SETA O VALOR PARA ABRIR PAGINAÇÃO
      this.exportarPagina = null

      // SETA O STATUS DA PAGINA
      this.botaoExportarXLSXStatus = ''
      this.botaoExportarPDFStatus = ''
      this.exportarStatus = ''

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    cpntTabelaOnChangeLinhaAdicional: function (id, atualizar = true) {
      // PROCURA O VALOR NO VETOR
      var index = this.linhaAdi.indexOf(id)

      // VERIFICA SE DEVE ADICONAR OU REMOVER
      if (index !== -1) {
        this.linhaAdi = this.linhaAdi.filter(item => item !== id)
      } else {
        this.linhaAdi.push(id)
      }

      if (atualizar === true) {
        this.$parent.$emit('TABELA_ATUALIZAR_LINHA_ADICIONAL', JSON.parse(JSON.stringify(this.linhaAdi)))
      }
    },
    cpntTabelaSetarFocusLinha: function (indexL) {
      if (this.$store.state.mobile === false) {
        this.focusL = indexL
      }
    },




















    cpntTabelaCheckboxMarcarTodos: function (event) {
      // VERIFICA SE O CHECKBOX FOI MARCADO
      var checked = event.target.checked === true

      // MARCA OU DESMARCA TODOS OS CHECKS EXISTENTES
      for (var indexC in this.$refs.cks) {
        if (checked !== this.$refs.cks[indexC].checked) {
          this.$refs.cks[indexC].click()
        }
      }
    },
    cpntTabelaCheckboxOnChange: function (event) {
      this.$emit('TABELA_MARCAR_CHECKBOX', event.target.checked, event.target.value, event)
    },
    cpntTabelaVerificarEditar: function (indexL, indexC) {
      // PEGA O NUMERO DA COLUNA QUE DEVE VERIFICAR
      var index = this.cpntColuna.findIndex(item => item.chave === this.colunas[indexC].chave)

      // VERIFICA SE TEM AÇÃO A EXECUTAR
      return (index !== -1 && [ '', null, undefined ].indexOf(this.cpntColuna[index].acao) === -1 && typeof this.cpntColuna[index].acao === 'function' && this.cpntColuna[index].acao(this.cpntLinha[indexL], this.cpntColuna[index]) === true)
    },
    cpntMostrarOcultarAcoesCelula: function (event, indexL, indexC, tipo = '', callback = null) {
      if (event.type === 'click' && this.editar === '') {
        // VERIFICA SE TEM AÇÃO A EXECUTAR
        if (this.cpntTabelaVerificarEditar(indexL, indexC) === true) {
          // PEGA O NUMERO DA COLUNA QUE DEVE VERIFICAR
          var index = this.cpntColuna.findIndex(item => item.chave === this.colunas[indexC].chave)

          // SETA O NOME DA CHAVE QUE DEVE PROCURAR
          var vetor = { indexL: indexL, index: index, indexC: indexC, indexLC: (indexL + '-' + index), tipo: tipo }
  
          // SETA O NOME DA AÇÃO
          vetor.chave = 'acao-' + vetor.indexLC
  
          // SETA O HASH DO CAMPO
          vetor.hash = new Date().getTime()

          // SETA A VARIAVEL DE OCULTAR A DIALOG
          this.ocultar_dialog = false
    
          // VERIFICA SE O CAMPO TEM AÇÃO
          if ([ '', null, undefined ].indexOf(this.$refs[vetor.chave]) === -1) {
            // VERIFICA SE JÁ TEM ALGUMA COISA ABERTA
            if (this.acoes !== null && (vetor.tipo === '' || vetor.tipo === this.acoes.tipo)) {
              vetor = null
            }
  
            // SETA O VALOR ATUALIZADO DA AÇÃO
            this.acoes = vetor
          }
        }
      }

      // EXECUTA O CALLBACK RECEBIDO
      if (callback !== null && typeof callback === 'function') {
        callback()
      }
    },
    cpntTabelaAcaoEditarSalvar: function (event) {
      this.cpntSalvarEdicao(() => { this.cpntTabelaAcaoEditarCancelar(event, () => { this.cpntTabelaBuscarLinhas() }) })
    },
    cpntTabelaAcaoEditarCancelar: function (event, callback = null) {
      if ([ '', null, undefined ].indexOf(this.acoes) !== -1 || [ '', null, undefined ].indexOf(this.acoes.indexL) !== -1) {
        callback()
      } else {
        this.cpntMostrarOcultarAcoesCelula(event, this.acoes.indexL, this.acoes.indexC, '', callback)
      }
    },
    cpntTabelaFundoLinha: function (indexL, linha) {
      // SETA O NOME DA CLASSE
      var _class = []

      // VERIFICA SE TEM CLASSE PARA FOCUS
      if ([ '', null, undefined ].indexOf(linha._fundoN) === -1) {
        _class.push(typeof linha._fundoN === 'function' ? linha._fundoN(linha, indexL) : linha._fundoN)
      }
      
      // VERIFICA SE DEVE COLOCAR CLASSE FOCUS
      if (this.focusL === indexL) {  
        if ([ '', null, undefined ].indexOf(linha._fundoF) === -1) {
          _class = typeof linha._fundoF === 'function' ? linha._fundoF(linha, indexL) : linha._fundoF
        } else {
          _class.push(this.focusL === indexL ? 'background-tp-1' : '')
        }
      }

      // RETORNA O VALOR MONTADO
      return _class
    },
    cpntTabelaValidarColunaCheck: function (chave, linha, indexL, indexC) {
      // PEGA O NUMERO DA COLUNA QUE DEVE VERIFICAR
      var index = this.cpntColuna.findIndex(item => item.chave === chave)
      
      // INCIA O NOME DA CHAVE DE VALIDAÇÃO
      var _chave = '_check_col_' + chave

        // VERIFICA SE PODE MOSTRAR O CONTEUDO DA COLUNA
      if ([ '', null, undefined ].indexOf(linha[_chave]) === -1) {
        return linha[_chave] === true
      } else {
        return [ '', null, undefined ].indexOf(this.cpntColuna[index].cpntValidaCheck) !== -1 || this.cpntColuna[index].cpntValidaCheck(linha, indexL, indexC, chave)
      }
    }
  },
  computed: {
    cpntTabelaMostrarTitulo: function () {
      // INICIA A VARIAVEL
      var valor = false

      // VERIFICA SE TEM O BOTAO EDITAR
      valor = valor === true || this.cpntBotaoEditar !== null

      // VERIFICA SE TEM O BOTAO EXCLUIR
      valor = valor === true || this.cpntBotaoExcluir !== null

      // VERIFICA SE TEM O BOTAO COPIAR
      valor = valor === true || this.cpntBotaoCopiar !== null

      // VERIFICA SE TEM MINHA PERSONALIZAÇÃO
      valor = valor === true || this.cpntMostrarMper !== false

      // VERIFICA SE TEM MINHA PERSONALIZAÇÃO
      valor = valor === true || ([ '', null, undefined ].indexOf(this.$slots) === -1 && [ '', null, undefined ].indexOf(this.$slots.titulo) === -1) 

      // VERIFICA SE TEM MINHA PERSONALIZAÇÃO
      valor = valor === true || this.total !== '__INICIAL__'

      // RETORNA O VALOR MONTADO
      return valor
    },
    cpntTabelaPaginacaoPassadorAnterior: function () {
      return (this.statusGeral === '' && this.liberado === true && this.pagina <= 1)
    },
    cpntTabelaPaginacaoPassadorProximo: function () {
      return (this.statusGeral === '' && this.liberado === true && this.pagina >= this.qtdePag)
    },
    cpntTabelaStatus: function () {
      return this.cpntStatus !== '' ? this.cpntStatus : this.statusGeral
    }
  },
  watch: {
    cpntColuna: function () {
      this.cpntTabelaSetarColunas()
    }
  }
}
</script>
